import type { TranslationShape } from './types';

export const fr: TranslationShape = {
  portfolio: {
    tools: 'Filtres et actions groupées',
    search: 'Rechercher des domaines',
    expiry: 'Payé jusqu’au',
    status: 'Statut',
    all: 'Tous',
    on: 'Activé',
    off: 'Désactivé',
    expiry_all: 'Toute date',
    expiry_expired: 'Expirés',
    expiry_30: '30 prochains jours',
    expiry_90: '90 prochains jours',
    expiryHint: 'Les dates incluent les renouvellements payés. Les périodes excluent les domaines déjà expirés.',
    count: '{{count}} domaines sur {{total}}',
    reset: 'Réinitialiser les filtres',
    exportFiltered: 'Exporter les résultats en CSV',
    exportSelected: 'Exporter la sélection en CSV',
    selected: '{{count}} sélectionnés',
    selectFiltered: 'Sélectionner tous les résultats',
    clear: 'Effacer la sélection',
    select: 'Sélectionner',
    selectDomain: 'Sélectionner {{domain}}',
    selectionHint: 'Sélectionnez jusqu’à {{limit}} domaines par action, sur plusieurs pages. Modifier les filtres efface la sélection.',
    renew: 'Ajouter les renouvellements au panier',
    enable: 'Activer le renouvellement automatique',
    disable: 'Désactiver le renouvellement automatique',
    review: 'Vérifier les domaines sélectionnés',
    renewHint: 'Ajoutez une année par domaine admissible au panier. Vérifiez les prix finaux et payez lors de la commande ; cette action ne vous facture rien.',
    enableHint: 'Les futurs renouvellements utiliseront votre configuration de paiement existante. Aucun renouvellement n’est payé maintenant.',
    disableHint: 'Vous devrez renouveler ces domaines manuellement pour les conserver. Les renouvellements payés et commandes en attente restent inchangés.',
    priceAtCheckout: 'Prix dans le panier',
    confirm: 'Confirmer pour ces domaines',
    results: 'Résultats',
    running: 'Traitement des domaines…',
    finished: 'Traitement terminé. Vérifiez les résultats ci-dessous.',
    retry: 'Réessayer les échecs',
    checkout: 'Vérifier le panier',
    added: 'Ajouté au panier',
    updated: 'Renouvellement automatique mis à jour',
    failed: 'Échec de la requête. Veuillez réessayer.',
    inactive: 'Non géré ici ; ignoré',
    paid: 'Renouvellement déjà payé ; ignoré',
    pending: 'Renouvellement en attente de paiement ; ignoré',
    unchanged: 'Déjà configuré ; ignoré',
    inCart: 'Déjà au panier ; ignoré',
    result_success: 'Réussi',
    result_failed: 'Échec',
    result_skipped: 'Ignoré',
    deleted: 'Supprimé',
    transferred: 'Transféré ailleurs',
    unknown: 'Inconnu',
    previous: 'Précédent',
    next: 'Suivant',
    page: 'Page {{page}} sur {{pages}}',
    sort: 'Trier par',
    sort_name: 'Nom de domaine',
    sort_expiry: 'Expiration la plus proche',
    sort_latest: 'Expiration la plus lointaine',
  },
  common: {
    search: 'Rechercher',
    add: 'Ajouter',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    close: 'Fermer',
    confirm: 'Confirmer',
    loading: 'Chargement...',
    name: 'Nom',
    email: 'E-mail',
    password: 'Mot de passe',
    status: 'Statut',
    type: 'Type',
    value: 'Valeur',
    valueOptional: 'Valeur (Facultatif)',
    address: 'Adresse',
    city: 'Ville',
    state: 'Canton',
    country: 'Pays',
    countryOrRegion: 'Pays ou région',
    phone: 'Téléphone',
    phoneNumber: 'Numéro de téléphone',
    code: 'Code',
    comment: 'Commentaire',
    settings: 'Paramètres',
    inUse: "En cours d'utilisation",
    inCart: 'Dans le panier',
    domain: 'Domaine',
    zipCode: 'Code postal',
    yes: 'Oui',
    no: 'Non',
    apply: 'Appliquer',
    verify: 'Vérifier',
    individual: 'Particulier',
    company: 'Entreprise',
    error: 'Erreur',
    default: 'Par défaut',
    total: 'Total',
    items: 'Articles',
    coupon: 'Coupon',
    remove: 'Retirer',
    disable: 'Désactiver',
    enabled: 'Activé',
    disabled: 'Désactivé',
    processing: 'Traitement...',
    saveChanges: 'Enregistrer les modifications',
    openMenu: 'Ouvrir le menu',
    paid: 'Payé',
    free: 'Gratuit',
    subtotal: 'Sous-total',
    discount: 'Remise',
    amountDue: 'Montant dû',
    product: 'Produit',
    quantity: 'Quantité',
    totalCost: 'Coût total',
    actions: 'Actions',
    pay: 'Payer',
    host: 'Hôte',
    destination: 'Destination',
    hostname: "Nom d'hôte",
    created: 'Créé',
    notFoundDescription: 'La page que vous recherchez doit encore être programmée.',
    goToHome: "Aller à l'accueil",
    notAuthenticated: 'Non authentifié',
    toggleTheme: 'Changer le thème',
    themeLight: 'Clair',
    themeDark: 'Sombre',
    themeSystem: 'Système',
    allSystemsNormal: 'Tous les systèmes fonctionnent',
    systemNotNormal: 'Système perturbé',
    previous: 'Précédent',
    next: 'Suivant',
    page: 'Page',
    rowsPerPage: 'Lignes par page',
    selectSection: 'Sélectionner une section',
    noResults: 'Aucun résultat.',
    searchCountry: 'Rechercher un pays...',
    noCountryFound: 'Aucun pays trouvé.',
    searchState: 'Rechercher un canton...',
    selectCountryFirst: "Sélectionnez d'abord un pays",
    price: 'Prix',
    faq: 'Questions fréquentes',
    perMonth: '/ mois',
    perYear: '/ an',
    overview: 'Aperçu',
    beta: 'Bêta',
    expired: 'Expiré',
    expiringSoon: 'Expire bientôt',
  },
  nav: {
    domains: 'Domaines',
    registration: 'Enregistrement',
    transfer: 'Transfert',
    tldPrices: 'Prix TLD',
    hosting: 'Hébergement',
    websiteHosting: 'Hébergement web',
    services: 'Services',
    docs: 'Docs',
    whoisLookup: 'Recherche Whois',
    whois: 'Whois',
    toggleMenu: 'Basculer le menu',
    legal: 'Juridique',
    termsOfService: "Conditions d'utilisation",
    domainRegistrationAgreement: "Contrat d'enregistrement de domaine",
    websiteHostingAgreement: "Contrat d'hébergement web",
    dataProcessingAgreement: 'Contrat de traitement des données',
    privacyPolicy: 'Politique de confidentialité',
    registrationDescription: 'Achetez un nouveau domaine chez YourWebTech.',
    transferDescription: 'Transférez votre domaine vers YourWebTech.',
    tldPricesDescription: 'Consultez les prix des TLD.',
    docsDescription: 'Consultez la documentation produit et les guides d’aide.',
  },
  auth: {
    login: 'Connexion',
    signIn: 'Se connecter',
    signUp: "S'inscrire",
    createAccount: 'Créer un compte',
    createAnAccount: 'Créer un compte',
    enterEmailToCreate: 'Entrez votre adresse e-mail ci-dessous pour créer votre compte',
    continueWithGoogle: 'Continuer avec Google',
    continueWithGitHub: 'Continuer avec GitHub',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    dontHaveAccount: "Vous n'avez pas de compte ?",
    resetPassword: 'Réinitialiser le mot de passe',
    emailAddress: 'Adresse e-mail',
    orYouCanAlso: 'Ou vous pouvez aussi',
    forgotPassword: 'Mot de passe oublié ?',
    forgotPasswordTitle: 'Mot de passe oublié',
    forgotPasswordDescription: 'Saisissez votre adresse e-mail et nous vous enverrons un lien pour choisir un nouveau mot de passe.',
    invalidCredentials: 'Identifiants invalides',
    signInUnavailable: 'La connexion est impossible pour le moment. Veuillez réessayer dans un instant.',
    accountCreated: 'Compte créé. Nous avons envoyé un lien de confirmation à {{email}}.',
    loggedOut: 'Déconnexion réussie',
    enterEmailToLogin: 'Entrez votre adresse e-mail ci-dessous pour vous connecter',
    twoFactorAuth: 'Authentification à deux facteurs',
    twoFactorDescription: "Entrez le code à 6 chiffres de votre application d'authentification pour continuer.",
    authenticationCode: "Code d'authentification",
    twoFactorTitle: 'Authentification à deux facteurs (TOTP)',
    twoFactorProtect: "Protégez votre compte en exigeant un code à usage unique d'une application d'authentification lors de la connexion.",
    twoFactorEnabled: "Un code de votre application d'authentification vous sera demandé lors de la connexion.",
    twoFactorEnableHint: "Activez TOTP pour générer un secret pour votre application d'authentification (par ex. Google Authenticator, 1Password, Authy).",
    twoFactorScanQr: "Scannez ce code QR dans votre application d'authentification",
    twoFactorSecretKey: 'Clé secrète (entrez manuellement si nécessaire)',
    twoFactorVerificationCode: "Code de vérification de votre application d'authentification",
    twoFactorSixDigitCode: 'Code à 6 chiffres',
    enable2fa: 'Activer la 2FA',
    disable2fa: 'Désactiver la 2FA',
    verifyAndEnable: 'Vérifier et activer',
    disable2faTitle: "Désactiver l'authentification à deux facteurs ?",
    disable2faDescription: 'Un code de vérification ne vous sera plus demandé lors de la connexion. Cela réduit la sécurité de votre compte.',
    // Auth store toasts
    mfaSessionExpired: 'Session MFA expirée. Veuillez vous reconnecter.',
    noMfaFactor: 'Aucun facteur MFA disponible.',
    mfaSignInError: 'Erreur lors de la connexion 2FA.',
    mustBeSignedIn2fa: 'Vous devez être connecté pour activer la 2FA.',
    failedStart2fa: "Échec du démarrage de l'inscription 2FA : ",
    totpSecretNotFound: "Secret TOTP introuvable. Veuillez relancer l'inscription.",
    twoFactorEnabledToast: 'Authentification à deux facteurs activée.',
    failedEnable2fa: "Échec de l'activation de la 2FA : ",
    mustBeSignedInDisable2fa: 'Vous devez être connecté pour désactiver la 2FA.',
    noTotpEnabled: "Aucun facteur TOTP n'est actuellement activé.",
    twoFactorDisabled: 'Authentification à deux facteurs désactivée.',
    failedDisable2fa: 'Échec de la désactivation de la 2FA : ',
    errorSigningUp: "Votre compte n'a pas pu être créé. Veuillez réessayer.",
    exitImpersonation: "Quitter l'usurpation d'identité",
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe',
    passwordRule: {
      minLength: 'Au moins 8 caractères',
      uppercase: 'Une lettre majuscule',
      lowercase: 'Une lettre minuscule',
      number: 'Un chiffre',
    },
    invalidEmail: 'Veuillez saisir une adresse e-mail valide',
    passwordRequired: 'Veuillez saisir votre mot de passe',
    passwordRequirementsNotMet: 'Le mot de passe ne remplit pas encore toutes les exigences',
    tooManyAttempts: 'Trop de tentatives. Veuillez patienter quelques minutes ou réinitialiser votre mot de passe.',
    wrongEmailOrPassword: "L'adresse e-mail ou le mot de passe est incorrect.",
    noAccountYet: 'Nouveau ici ?',
    createAccountWithEmail: 'Créer un compte avec {{email}}',
    emailAlreadyRegistered: 'Un compte existe déjà avec cette adresse e-mail.',
    signInInstead: 'Se connecter',
    errorSendingResetLink: "L'e-mail n'a pas pu être envoyé. Veuillez réessayer dans un instant.",
    sendResetLink: 'Envoyer le lien',
    checkYourInbox: 'Consultez votre boîte de réception',
    resetLinkSent: "S'il existe un compte pour {{email}}, nous lui avons envoyé un lien pour choisir un nouveau mot de passe.",
    resetLinkHelp: "Le lien est valable 1 heure. Rien reçu ? Vérifiez votre dossier de courrier indésirable ou assurez-vous qu'il s'agit de l'adresse de votre inscription.",
    useDifferentEmail: 'Utiliser une autre adresse e-mail',
    backToSignIn: 'Retour à la connexion',
    emailConfirmed: 'Adresse e-mail confirmée',
    emailConfirmedDescription: 'Merci. Nous utiliserons cette adresse pour vos factures et les avis concernant vos domaines.',
    goToAccount: 'Accéder à votre compte',
    chooseNewPassword: 'Choisir un nouveau mot de passe',
    chooseNewPasswordFor: 'Pour {{email}}',
    newPassword: 'Nouveau mot de passe',
    saveAndSignIn: 'Enregistrer et se connecter',
    linkInvalid: "Ce lien n'est plus valable",
    verifyLinkInvalidDescription: "Il a peut-être expiré ou déjà été utilisé. Si votre adresse n'est pas encore confirmée, vous pouvez demander un nouveau lien depuis votre compte.",
    resetLinkInvalidDescription: 'Les liens de réinitialisation fonctionnent une seule fois et pendant 1 heure. Demandez-en un nouveau pour choisir votre mot de passe.',
    requestNewLink: 'Demander un nouveau lien',
    confirmEmailNotice: 'Veuillez confirmer votre adresse e-mail {{email}} avec le lien que nous vous avons envoyé, afin que nos factures et avis concernant vos domaines vous parviennent.',
    verificationEmailResent: 'Nous avons envoyé un nouveau lien à {{email}}.',
    resendVerificationEmail: 'Renvoyer le lien',
    errorSendingVerificationEmail: "L'e-mail n'a pas pu être envoyé. Veuillez réessayer plus tard.",
  },
  domain: {
    batch: {
      single: 'Un seul domaine',
      title: 'Transfert par lot',
      description: 'Importez ou collez jusqu’à {{count}} domaines .ch/.li avec leurs codes de transfert.',
      nameservers: 'Vos serveurs de noms actuels sont conservés. Si votre ancien prestataire héberge aussi votre DNS, vérifiez que ce service continuera après le transfert.',
      upload: 'Importer un CSV',
      paste: 'Coller les domaines et les codes de transfert',
      format:
        'Deux colonnes : domain, auth_code. Virgules, points-virgules et tabulations acceptés ; l’en-tête est facultatif. Maximum 64 Ko. Utilisez la notation xn-- pour les noms internationalisés.',
      preview: 'Prévisualiser les domaines',
      review: 'Vérifiez {{count}} domaines. Corrigez ou supprimez les lignes invalides, puis vérifiez leur éligibilité au transfert.',
      pricing: 'Prix par domaine',
      transferPrice: 'Transfert :',
      renewalPrice: 'Renouvellement / an :',
      checkoutPrice: 'Prix confirmé à la commande',
      check: 'Vérifier les domaines ({{count}})',
      add: 'Ajouter les domaines prêts ({{count}})',
      startOver: 'Importer une autre liste',
      cartNotice:
        'Seuls les domaines prêts sont ajoutés. Vérifiez les prix définitifs avant de confirmer le transfert. Supprimer une ligne de l’aperçu ne supprime pas un domaine déjà dans votre panier.',
      checkout: 'Continuer vers le panier',
      working: 'Traitement des domaines. Veuillez garder cette page ouverte.',
      remove: 'Supprimer',
      removeRow: 'Supprimer la ligne {{count}}',
      domainRow: 'Domaine à la ligne {{count}}',
      codeRow: 'Code de transfert à la ligne {{count}}',
      empty: 'Saisissez au moins un domaine et son code de transfert.',
      tooLarge: 'La saisie dépasse 64 Ko. Divisez-la en fichiers plus petits.',
      tooMany: 'Un lot peut contenir au maximum {{count}} domaines. Divisez votre liste.',
      malformed: 'Le fichier CSV contient des guillemets incorrects. Vérifiez les champs et réessayez.',
      columns: 'Chaque ligne doit contenir exactement deux colonnes : domain et auth_code.',
      readFailed: 'Impossible de lire le fichier. Réessayez ou collez son contenu.',
      invalidDomain: 'Saisissez un domaine .ch ou .li valide, sans URL ni sous-domaine.',
      missingCode: 'Saisissez un code de transfert.',
      invalidCode: 'Le code contient un saut de ligne, un caractère de contrôle ou plus de 1 024 caractères.',
      duplicate: 'Ce domaine apparaît plusieurs fois. Supprimez la ligne en double.',
      inCart: 'Déjà dans votre panier.',
      unchecked: 'Pas encore vérifié',
      checking: 'Vérification…',
      ready: 'Prêt à être ajouté',
      unavailable: 'Transfert impossible. Vérifiez le code et le statut auprès de votre registrar actuel.',
      checkFailed: 'La vérification a échoué. Réessayez pour ce domaine.',
      adding: 'Ajout au panier…',
      added: 'Ajouté au panier',
      addFailed: 'Impossible d’ajouter au panier. Réessayez pour cette ligne.',
    },
    domain: 'Domaine',
    domainName: 'Nom de domaine',
    creationDate: 'Date de création',
    expirationDate: "Date d'expiration",
    autoRenewal: 'Renouvellement automatique',
    autoRenew: 'Renouvellement automatique',
    registrar: 'Registrar',
    nameservers: 'Serveurs de noms',
    nameserversAndDns: 'Serveurs de noms et enregistrements DNS',
    nameserversTitle: 'Serveurs de noms',
    nameserversDescription:
      'Par défaut, nous utilisons les serveurs de noms YWT pour votre domaine. Vous pouvez les remplacer par vos propres serveurs de noms. Dans ce cas, les enregistrements DNS seront gérés par vos propres serveurs de noms.',
    nameserversChanged: 'Serveur de noms modifié avec succès',
    urlForwarding: "Redirection d'URL",
    rootHint: 'Utilisez @ pour la racine.',
    addToCart: 'Ajouter au panier',
    tooLong: 'Domaine trop long !',
    tooShort: 'Domaine trop court !',
    port: 'Port',
    priority: 'Priorité',
    target: 'Cible',
    ttl: 'TTL',
    weight: 'Poids',
    manageDomain: 'Gérer votre domaine',
    whoisPrivacy: 'Confidentialité Whois',
    whoisPrivacyEnabled: 'La confidentialité Whois est activée par défaut. Vos informations de contact ne sont pas visibles publiquement.',
    dnssec: 'DNSSEC',
    dnssecFull: 'Sécurité du système de noms de domaine (DNSSEC)',
    dnssecUpdated: 'DNSSEC mis à jour',
    dnssecRecordAdded: 'Enregistrement DNSSEC ajouté',
    dnssecRecordRemoved: 'Enregistrement DNSSEC supprimé',
    acmeKeysTitle: 'Automatisation des certificats (ACME)',
    acmeKeysDescription:
      "Des clés pour certbot, acme.sh ou lego, afin qu'ils renouvellent les certificats Let's Encrypt ou ZeroSSL de ce domaine, wildcards compris, avec le challenge DNS-01. Une clé peut seulement ajouter et supprimer des enregistrements TXT aux noms _acme-challenge de ce domaine.",
    acmeKeysEmpty: 'Aucune clé pour le moment.',
    acmeKeyCreate: 'Créer une clé',
    acmeKeyCreateHint: "La clé peut seulement ajouter et supprimer des enregistrements TXT aux noms _acme-challenge de ce domaine. Son secret s'affiche une seule fois, juste après la création.",
    acmeKeyLabel: 'Libellé',
    acmeKeyLabelPlaceholder: 'Par exemple : serveur web (facultatif)',
    acmeKeyUnnamed: 'Sans libellé',
    acmeKeyName: 'Nom de la clé',
    acmeKeyCreated: 'Créée le',
    acmeKeyRevoke: 'Révoquer',
    acmeKeyRevokeTitle: 'Révoquer cette clé ?',
    acmeKeyRevokeConfirm: "Les outils de certificats qui l'utilisent ne peuvent plus modifier le DNS : leur prochain renouvellement échoue tant qu'ils n'ont pas de nouvelle clé.",
    acmeKeyLimit: "Un domaine peut avoir jusqu'à {{count}} clés. Révoquez-en une pour en créer une autre.",
    acmeKeyDocs: "Guide d'installation",
    acmeKeyCreatedTitle: 'Clé créée',
    acmeKeySecretOnce: "Copiez le secret maintenant : il ne s'affiche que cette fois. Si vous le perdez, révoquez la clé et créez-en une nouvelle.",
    acmeKeyServer: 'Serveur',
    acmeKeyAlgorithm: 'Algorithme',
    acmeKeySecret: 'Secret',
    acmeKeySaveFile: 'Enregistrez ceci sous {{path}}, lisible uniquement par root :',
    acmeKeyThenRun: 'Puis exécutez :',
    acmeKeyRun: 'Exécutez :',
    acmeKeyDone: 'Terminé',
    acmeKeyCopy: 'Copier',
    acmeKeyCopied: 'Copié',
    acmeKeyCopyFailed: 'Copie impossible. Sélectionnez le texte et copiez-le manuellement.',
    acmeKeyCnameConflict:
      "_acme-challenge est un CNAME (vers {{target}}), ces clés ne peuvent donc pas y écrire d'enregistrements de challenge. Supprimez ce CNAME dans les enregistrements DNS ci-dessus pour les utiliser avec ce domaine.",
    dnssecYwtHint: 'Vous utilisez les serveurs de noms YWT. Vous pouvez facilement activer ou désactiver DNSSEC en un clic.',
    dnssecAdvanced: 'Gestion avancée DNSSEC',
    dnssecAdvancedHint: 'Gérez vos enregistrements DS (DNSSEC) de domaine ici. Vous savez ce que vous faites !',
    dnssecNoRecords: 'Aucun enregistrement DNSSEC.',
    dnssecAddRecord: 'Ajouter un enregistrement DNSSEC',
    dnssecProvideDs: "Fournissez les valeurs de l'enregistrement DS. Les données de clé sont facultatives.",
    dnssecKeyTag: 'Étiquette de clé',
    dnssecAlgorithm: 'Algorithme',
    dnssecDigestType: 'Type de condensé',
    dnssecDigest: 'Condensé',
    dnssecHexDigest: 'Condensé hexadécimal (96 caractères max.)',
    dnssecIncludeKeyData: 'Inclure les données de clé',
    dnssecOptional: '[facultatif]',
    dnssecFlags: 'Indicateurs',
    dnssecProtocol: 'Protocole',
    dnssecKeyAlgorithm: 'Algorithme de clé',
    dnssecPublicKey: 'Clé publique',
    dnssecBase64Key: 'Clé Base64',
    dnssecFixedProtocol: 'Fixe : 3',
    dnssecKeyDataRequired: 'Requis lorsque les données de clé sont incluses',
    dnssecFillRequired: 'Veuillez remplir keyTag, algorithme, digestType et digest',
    dnssecKeyTagRange: 'keyTag doit être compris entre 0 et 65535',
    dnssecDigestMax: 'Le condensé doit contenir au maximum 96 caractères',
    dnssecKeyDataFieldsRequired: "Les indicateurs, le protocole, l'algorithme de clé et la clé publique sont requis lors de l'inclusion des données de clé",
    dnssecKeyTagLabel: 'Clé tag :',
    dnssecAlgLabel: 'Alg. :',
    dnssecDigestTypeLabel: 'Type digest :',
    dnssecDigestLabel: 'Digest :',
    dnssecSelect: 'Sélectionner',
    dnssecAllowedAlgorithms: 'Autorisé : 8, 10, 13, 14, 15, 16',
    dnssecAllowedDigestTypes: 'Autorisé : 2 ou 4',
    searchTitle: 'Rechercher un domaine .ch/.li',
    searchDescription: "Enregistrer un domaine n'a jamais été aussi simple, clair et rapide.",
    searchPlaceholder: 'Trouvez votre domaine de rêve ici...',
    searchInfoTitle: 'À propos des domaines .ch et .li',
    searchInfoIntro:
      "YourWebTech est un registrar suisse accrédité (SWITCH). Recherchez ci-dessus n'importe quel nom en .ch ou .li, vérifiez sa disponibilité et enregistrez-le en quelques minutes — DNSSEC, contrôle DNS complet et confidentialité Whois sont inclus avec chaque domaine.",
    faqRegEligibilityQ: 'Qui peut enregistrer un domaine .ch ou .li ?',
    faqRegEligibilityA:
      "Les domaines .ch et .li sont ouverts à tous, partout dans le monde — aucune condition de résidence ou de présence locale n'est requise. Il vous suffit de fournir des coordonnées valides.",
    faqRegSpeedQ: "Combien de temps prend l'enregistrement ?",
    faqRegSpeedA:
      "Les enregistrements passent par le registre suisse SWITCH et aboutissent généralement en quelques minutes. Votre domaine et votre DNS sont gérables dès que l'opération est terminée.",
    faqRegDnssecQ: 'DNSSEC et la gestion DNS sont-ils inclus ?',
    faqRegDnssecA:
      'Oui. Chaque domaine comprend DNSSEC gratuit, nos serveurs de noms suisses et un éditeur simple pour les enregistrements A, AAAA, CNAME, MX, TXT et autres — sans frais supplémentaires.',
    faqRegTransferInQ: 'Puis-je transférer un domaine que je possède déjà ?',
    faqRegTransferInA:
      "Oui — vous pouvez transférer gratuitement vos domaines .ch et .li existants vers YourWebTech. Commencez depuis la page de transfert avec le code d'autorisation de votre domaine.",
    transferTitle: 'Transférer un domaine .ch/.li',
    transferDescription: "Assez d'attendre une semaine ? Contrairement à d'autres registrars, nous offrons des transferts de domaine <bold>instantanés</bold>.",
    transferNotAvailable: "Le domaine n'est pas disponible pour le transfert",
    perYear: '/ an',
    renewsAt: 'se renouvelle à',
    registration: 'Enregistrement',
    renewal: 'Renouvellement',
    renewalDescription: 'Gérez le renouvellement automatique et créez une commande de renouvellement si nécessaire.',
    autoRenewalLabel: 'Renouvellement automatique',
    autoRenewalHint: "Recevez un e-mail de rappel avec un lien de paiement 30 jours avant l'expiration.",
    autoRenewalEnabled: 'Renouvellement automatique activé',
    autoRenewalDisabled: 'Renouvellement automatique désactivé',
    autoRenewalInfo:
      "Si activé, vous recevrez un prélèvement automatique ou un e-mail de rappel 30 jours avant l'expiration. Sinon, le domaine risque d'expirer et vous devrez le renouveler manuellement.",
    renewNow: 'Renouveler maintenant',
    renewNowHint: 'Créez une commande de renouvellement instantanément et payez immédiatement.',
    renewalAddedToCart: 'Renouvellement ajouté au panier',
    renewalOrderCreated: 'Commande de renouvellement prête',
    renewalFeePaidTill: "Frais de renouvellement payés jusqu'au {{date}}",
    goToCart: 'Aller au panier',
    noDomains: 'Aucun domaine',
    noDomainsDescription: "Vous n'avez pas encore enregistré de domaine.",
    copyNameservers: 'Copier les serveurs de noms',
    ywtNs: 'NS YourWebTech',
    ywtNsTooltip: 'YWT utilise les serveurs DNS suivants pour ce domaine : ',
    expires: 'Expire :',
    dnsRecords: 'Enregistrements DNS',
    dnsRecordsDescription: "Les enregistrements DNS pointent vers les services utilisés par votre domaine, comme la redirection de votre domaine ou la configuration d'un service de messagerie.",
    dnsOwnNameservers: 'Vous utilisez vos propres serveurs de noms.',
    dnsOwnNameserversHint: 'Vous pouvez gérer vos enregistrements DNS directement chez votre fournisseur de serveurs de noms.',
    dnsFailedToAdd: "Échec de l'ajout de l'enregistrement DNS",
    dnsEditRecord: "Modifier l'enregistrement {{type}}",
    dnsEditRecordHint: "Apportez vos modifications à l'enregistrement ici. Cliquez sur enregistrer lorsque vous avez terminé.",
    dnsDeleteRecord: "Supprimer l'enregistrement",
    dnsDeleteConfirm: "Vous êtes sur le point de supprimer l'enregistrement suivant, êtes-vous sûr de vouloir continuer ?",
    dnsAuto: 'Auto',
    dnsAutoTooltip: 'Les enregistrements DNS sont gérés automatiquement',
    removeDomain: 'Supprimer le domaine',
    removeDomainDescription: 'Supprimer le domaine de votre compte.',
    removeDomainConfirm: 'Êtes-vous sûr de vouloir supprimer le domaine <strong>{{domain}}</strong> de votre compte ?',
    removeDomainIrreversible: 'Cette action est irréversible et le domaine sera supprimé de votre compte.',
    removeDomainSuccess: 'Domaine supprimé de votre compte.',
    yesRemoveIt: 'Oui, le supprimer',
    dangerZone: 'Zone de danger',
    dangerZoneDescription: 'Les fonctionnalités dont vous avez rarement besoin.',
    transferOut: 'Transférer vers un autre registrar',
    transferOutHint: "Vous avez juste cliqué sur le mauvais bouton, n'est-ce pas ? Saviez-vous que vous n'avez pas besoin de transférer votre domaine pour l'héberger ailleurs ?",
    transferOutConfirm:
      "Mais si vous êtes sûr de vouloir transférer <strong>{{domain}}</strong>, nous vous faciliterons la tâche en générant un nouveau code d'autorisation et en vous l'envoyant par e-mail.",
    transferOutSuccess: "Nous vous avons envoyé le code d'autorisation par e-mail.",
    transferOutNotAllowed: 'Transfert sortant non autorisé.',
    yesMadeUpMind: 'Oui, ma décision est prise',
    transferProhibitedInfo: "Le domaine n'est actuellement pas transférable. Si vous venez de transférer le domaine chez nous, c'est normal.",
    transferredAwayBadge: 'Transféré ailleurs',
    transferredAwayTitle: 'Ce domaine a été transféré vers un autre registrar.',
    transferredAwayDescription: "Il n'est plus géré par YourWebTech et n'est affiché ici qu'à titre indicatif. Vous pouvez le retirer de votre compte à tout moment.",
    deletedTitle: 'Ce domaine a été supprimé',
    deletedRestorable: "Il a expiré et a été supprimé auprès du registre : son site web, ses e-mails et ses autres services ne fonctionnent plus. Vous pouvez le restaurer jusqu'au {{date}}.",
    restoreIncludesYear: "Le prix comprend l'année suivante.",
    restoreKeepsDns: 'Ses enregistrements DNS sont conservés. Les sites web et redirections URL qui l’utilisaient doivent être ajoutés à nouveau après la restauration.',
    restoreAfterDeadline: "Après le {{date}}, n'importe qui peut l'enregistrer.",
    restoreDomainFor: 'Restaurer pour {{price}}',
    deletedNoLongerRestorable: "Il a expiré, a été supprimé auprès du registre et ne peut plus être restauré. Dès que le registre le libère, n'importe qui peut l'enregistrer à nouveau.",
    deletedRestoreBySupport: 'Il a expiré et a été supprimé auprès du registre. Pour le restaurer, veuillez contacter notre support.',
    restorableUntilBadge: "Supprimé · restaurable jusqu'au {{date}}",
    deletedBadge: 'Supprimé',
    oneYear: '1 an',
    oneYearTooltip:
      "Le registre n'autorise qu'un enregistrement d'un an maximum. Mais ne vous inquiétez pas, nous mettrons en place le renouvellement automatique pour chaque domaine jusqu'à ce que vous l'annuliez.",
    // URL Forwarding
    urlForwardingTitle: "Redirection d'URL",
    urlForwardingDescription: 'Redirigez votre domaine (et éventuellement des sous-domaines) vers un autre site web.',
    howForwardingWorks: 'Comment fonctionne la redirection',
    howForwardingWorksDescription:
      "Créez une ou plusieurs règles de redirection ci-dessous. Laissez le nom d'hôte vide pour rediriger le domaine racine. Activez la redirection générique pour également rediriger les sous-hôtes. La redirection prend effet normalement en quelques minutes.",
    editRule: 'Modifier la règle',
    addNew: 'Ajouter',
    hostnameLabel: "Nom d'hôte",
    blankForRoot: '(vide pour la racine)',
    hostnameExample: 'Exemple : "www" redirige {{hostname}}',
    forwardTrafficTo: 'Rediriger le trafic vers',
    invalidUrlHint: 'Entrée invalide. Doit commencer par http ou https',
    wildcardForwarding: 'Redirection générique',
    wildcardForwardingHint: "Rediriger également les sous-hôtes de ce nom d'hôte",
    wildcardForwardingInfo:
      'Lorsque cette option est activée, cette règle redirige également les sous-hôtes. Exemple : nom d\'hôte "abc" + générique redirige à la fois "abc.{{host}}" et "*.abc.{{host}}" (par ex. def.abc.example.com").',
    includePathLabel: 'Inclure le chemin',
    includePathHint: 'Ajouter le chemin et la requête à la destination',
    includePathInfo: 'Lorsque cette option est activée, le chemin et la requête demandés (par ex. "/docs?x=1") seront ajoutés à l\'URL de destination.',
    advancedLabel: 'Avancé',
    advancedHint: 'Code de statut (par défaut 307)',
    advancedInfo: 'Choisissez le code de statut de redirection. Par défaut 307 (temporaire) pour préserver la méthode et le corps.',
    redirectType: 'Type de redirection',
    selectStatusCode: 'Sélectionner le code de statut',
    updateRule: 'Mettre à jour la règle',
    addRule: 'Ajouter la règle',
    currentForwards: 'Redirections actuelles',
    noForwards: 'Aucune redirection configurée.',
    includePath: 'Inclure le chemin',
    noPath: 'Sans chemin',
    checking: 'Vérification...',
    dnsOk: 'OK',
    dnsOkTooltip: 'Le DNS pointe correctement vers nos serveurs',
    dnsMissing: 'Manquant',
    dnsConfigRequired: 'Configuration DNS requise',
    dnsAutoAdded: 'Ces enregistrements devraient être ajoutés automatiquement. Cliquez sur "Re-vérifier" s\'ils n\'apparaissent pas.',
    dnsAddRecords: 'Ajoutez les enregistrements DNS suivants via votre fournisseur DNS :',
    recheckDns: 'Re-vérifier le DNS',
    sslActive: 'Actif',
    sslActiveTooltip: 'Le certificat SSL est actif',
    sslWaitingForDns: 'En attente du DNS',
    sslWaitingForDnsTooltip: 'HTTPS démarre automatiquement dès que le DNS pointe vers YourWebTech',
    sslIssuing: 'Émission en cours',
    sslIssuingTooltip: "Le certificat SSL est en cours d'émission, généralement en moins d'une minute",
    editRuleTooltip: 'Modifier la règle',
    deleteRuleTooltip: 'Supprimer la règle',
    permanentRedirectWarning: 'Avertissement de redirection permanente',
    permanentRedirectBody: 'Vous êtes sur le point de créer une <strong>redirection permanente ({{code}})</strong>.',
    permanentRedirectCacheWarning:
      'Les navigateurs et les moteurs de recherche mettent en cache les redirections permanentes de manière agressive. Si vous faites une erreur, les utilisateurs pourraient continuer à être redirigés même après la suppression de la règle.',
    permanentRedirectSuggestion: 'Utilisez une redirection temporaire (302 ou 307) si vous testez ou si vous pourriez avoir besoin de modifier cela plus tard.',
    permanentRedirectConfirm: 'Je comprends, créer la redirection permanente',
    forwardAdded: 'Redirection ajoutée',
    forwardUpdated: 'Redirection mise à jour',
    forwardingRemoved: 'Redirection supprimée',
    forwardRemoved: 'Redirection supprimée',
    ruleEnabled: 'Règle activée',
    ruleDisabled: 'Règle désactivée',
    transferDomainPlaceholder: 'Le domaine à transférer',
    authCodePlaceholder: "Le code d'autorisation",
    // Nameservers
    useYwtNameservers: 'Utiliser les nameservers YWT',
    useYwtNameserversDescription: 'Utilisez nos nameservers par défaut pour gérer vos enregistrements DNS automatiquement.',
    defaultNameservers: 'Nameservers par défaut :',
    customNameservers: 'Nameservers personnalisés :',
    noneConfigured: 'Aucun configuré',
    nameserver1: 'Nameserver 1',
    nameserver2: 'Nameserver 2',
    nameserver3Optional: 'Nameserver 3 (Facultatif)',
    nameserver4Optional: 'Nameserver 4 (Facultatif)',
    dnsCommentPlaceholder: 'Un commentaire expliquant à quoi sert cet enregistrement DNS.',
    dnsCommentDescription: "Ceci est uniquement pour votre référence et n'aura aucun impact sur votre enregistrement DNS.",
    // Domain pricing page
    pricingTitle: 'Prix des domaines',
    pricingSubtitle: "Le renouvellement coûte le même prix que l'enregistrement, et le transfert est gratuit. Pas de première année bon marché qui devient chère ensuite.",
    pricingHeadline: '{{price}} par an. Chaque année.',
    compareTitle: 'Ce que coûte un domaine .ch sur {{years}} ans',
    compareSubtitle: 'Beaucoup de registrars offrent un rabais la première année et le récupèrent à chaque renouvellement.',
    compareRegistrar: 'Registrar',
    compareFirstYear: 'Première année',
    compareRenewal: 'Chaque renouvellement',
    compareTotal: '{{years}} ans',
    compareMoreThanUs: 'Plus cher que YWT',
    compareFootnote: 'Prix TVA suisse incluse, tels que publiés sur le site de chaque registrar le {{date}}. Total = première année + un renouvellement par année supplémentaire.',
    domainTld: 'Domaine TLD',
    vatNote: '*Les prix incluent 8,1% de TVA suisse pour les clients en Suisse.',
    findYourDomain: 'Trouvez votre domaine',
    whatsIncludedDomain: 'Ce qui est inclus avec chaque domaine',
    ywtDnsServers: 'Serveurs DNS YWT',
    dnssecSupportFeature: 'Support DNSSEC',
    urlForwardingFeature: "Redirection d'URL",
    easyDnsManagement: 'Gestion DNS simplifiée',
    greatUx: 'Excellente expérience utilisateur',
    freeTransfers: 'Transferts gratuits',
    emailSupport: 'Support par e-mail',
    noHiddenFees: 'Aucun frais caché',
    faqTrustQ: 'Puis-je vous faire confiance ?',
    faqTrustA:
      'Nous sommes un registraire accrédité reconnu par le registre officiel suisse \u2014 <switch>SWITCH</switch>. Cela devrait prouver que nous prenons notre activité et nos clients au sérieux.',
    faqVatQ: 'Comment la TVA est-elle gérée ?',
    faqVatA:
      "Le prix affiché est le même pour tout le monde. Les clients suisses ont 8,1% de TVA incluse dans le prix (indiquée sur les factures). Les clients hors de Suisse paient le même montant mais la TVA suisse ne s'applique pas.",
    faqHiddenFeesQ: 'Y a-t-il des frais cachés ?',
    faqHiddenFeesA: "Non. Notre tarification est transparente. Ce que vous voyez est ce que vous payez. Nous ne facturons aucun frais d'installation, de service ou autre.",
    faqRenewalPriceQ: "Le prix de renouvellement est-il le même que le prix d'enregistrement ?",
    faqRenewalPriceA:
      "Oui, contrairement à de nombreux registraires qui vous attirent avec un prix de première année ultra bas puis triplent le prix de renouvellement, nous facturons le même prix pour le renouvellement que pour l'enregistrement.",
    faqTransfersQ: 'Vous ne facturez rien pour les transferts de domaines ?',
    faqTransfersA: 'Exactement, nous ne facturons pas les transferts de domaines. Nous accueillons tous les titulaires de domaines et les invitons à profiter de nos services.',
    faqPaymentMethodsQ: 'Quels modes de paiement acceptez-vous ?',
    faqPaymentMethodsA: "Nous acceptons toutes les principales cartes de crédit (Visa, Mastercard, American Express). D'autres modes de paiement pourront être évalués et ajoutés à l'avenir.",
    faqPriceChangesQ: 'Les prix peuvent-ils changer ?',
    faqPriceChangesA:
      "De nombreux facteurs peuvent influencer le prix d'un domaine. Par exemple, <switch>SWITCH</switch> peut modifier les coûts de gros, les coûts d'infrastructure peuvent fluctuer, etc. Mais nous essayons de maintenir les prix aussi accessibles que possible.",
    faqRefundsQ: 'Puis-je demander un remboursement ?',
    faqRefundsA:
      "Si un domaine est enregistré ou renouvelé avec succès, vous ne pouvez pas demander de remboursement car il a déjà été traité auprès de <switch>SWITCH</switch>. Si votre enregistrement, transfert ou renouvellement de domaine n'a pas abouti, veuillez contacter le support et nous vous aiderons.",
    faqMoreThanOneYearQ: "Puis-je enregistrer un domaine pour plus d'un an ?",
    faqMoreThanOneYearA:
      "Il n'est techniquement pas possible d'enregistrer des domaines .ch/.li pour plus d'un an. Le registre <switch>SWITCH</switch> n'autorise l'enregistrement que pour un an maximum.",
    expirationRenewalTooltip: "La date d'expiration actuelle du domaine est {{registryDate}} dans le registre. Mais il sera renouvelé automatiquement jusqu'au {{renewalDate}}.",
  },
  checkout: {
    paymentDetail: 'Détails du paiement',
    enterBillingAddress: "Entrer l'adresse de facturation",
    editBillingAddress: "Modifier l'adresse de facturation",
    payNow: 'Payer maintenant',
    payOrder: 'Payer la commande',
    noPay: "Je n'ai pas besoin de payer",
    paymentSecureForm: 'Utilisez le formulaire sécurisé ci-dessous pour effectuer votre paiement.',
    paymentFormUnavailable: 'Formulaire de paiement indisponible',
    paymentFormUnavailableDescription: "Stripe n'a pas pu se charger. Vérifiez les bloqueurs de contenu ou votre connexion réseau, puis actualisez cette page.",
    paymentMethodNotAvailable: "Veuillez nous informer si votre méthode de paiement préférée n'est pas disponible.",
    savePaymentMethod: 'Enregistrer cette méthode de paiement pour les achats futurs',
    termsAccept: '*En passant cette commande, vous acceptez nos',
    termsOfService: "Conditions d'utilisation",
    privacyNotice: 'et reconnaissez avoir lu et compris notre',
    privacyPolicy: 'Politique de confidentialité',
    unexpectedError: "Une erreur inattendue s'est produite.",
    paymentProcessingTitle: 'Confirmation de votre paiement…',
    paymentProcessingDescription: 'Votre commande a bien été reçue et nous confirmons le paiement. Cela peut prendre quelques secondes — inutile de payer à nouveau.',
    viewOrderStatus: 'Voir le statut de la commande',
    paymentFailedTitle: "Votre paiement n'a pas abouti",
    paymentFailedDescription: "Le paiement a été refusé ou n'a pas été finalisé : aucun montant n'a été débité. Vous pouvez réessayer avec le même moyen de paiement ou un autre.",
    retryPayment: 'Réessayer le paiement',
    orderReview: 'Récapitulatif de la commande',
    orderDescription: 'Voici la liste des articles de votre commande. (ID de commande : {{orderId}})',
    finishOrder: 'Finaliser votre commande',
    reviewAndPay: 'Vérifiez votre commande et procédez au paiement.',
    emptyOrder: 'Cette commande est vide. Veuillez supprimer cette commande et rechercher à nouveau des domaines.',
    domainsUnavailable: 'Certains domaines de cette commande ne sont plus disponibles. Cette commande est invalide. Veuillez supprimer cette commande et rechercher à nouveau des domaines.',
    paymentMethods: 'Méthodes de paiement',
    newPaymentMethod: 'Nouvelle méthode de paiement',
    couponCode: 'Code coupon',
    vatExempt: '(Non soumis à la TVA suisse)',
    vatIncluded: '(8.1% TVA incl.)',
    websiteHosting: 'Hébergement web',
    notApplicable: 'Non applicable',
    yourCart: 'Votre panier',
    cartDescription: 'Commencez votre aventure web ici.',
    cartEmpty: 'Votre panier est vide.',
    addMoreToCart: "Ajouter d'autres articles au panier",
    continueToCheckout: 'Continuer vers le paiement',
    goToCheckout: 'Aller au paiement',
    unpaidOrders: 'Mais vous avez des commandes impayées.',
    unpaidRenewalOrders: 'Commandes de renouvellement impayées :',
    viewAmountsDue: 'Voir les montants dus',
    amountsDue: 'Montants dus',
    amountsDueDescription: 'Consultez les commandes de renouvellement impayées et regroupez-les dans une facture.',
    amountsDueEmpty: "Il n'y a actuellement aucune commande de renouvellement impayée.",
    payAllInOneInvoice: 'Tout payer en une facture',
    renewalOrderDomainCount: '{{count}} articles de renouvellement de domaine',
    viewOrders: 'Voir les commandes',
    order: 'Commande',
    thankYou: 'Merci !',
    paymentReceived: 'Votre paiement a été reçu.',
    freeOrderPlaced: 'Vous avez passé une commande gratuite.',
    orderProcessing: 'Nous traiterons votre commande et vous enverrons un e-mail de confirmation dans quelques minutes.',
    domainItems: 'Articles de domaine :',
    amountPaid: 'Montant payé :',
    amountRemaining: 'Montant restant :',
    dateAndTime: 'Date et heure :',
    viewMyOrder: 'Voir ma commande {{id}}',
    goToMyWebsite: 'Aller à mon site web',
    goToMyWebsites: 'Aller à mes sites web',
    orderFrom: 'Commande {{id}} du {{date}}',
    totalDue: 'Total dû',
    invoiceNumber: 'Numéro de facture',
    domainType: 'Domaine {{type}}',
    deleteOrder: 'Supprimer la commande',
    deleteOrderConfirm: 'Vous êtes sur le point de supprimer la commande {{id}}, êtes-vous sûr de vouloir continuer ?',
    orderDeletedSuccess: 'Commande supprimée avec succès',
    oneYear: '1 an',
    oneMonth: '1 mois',
    upgradeToPlan: 'Passer au plan {{plan}}',
    plan: 'Plan {{plan}}',
    days: '{{count}} jours',
    daysUntilDate: "({{count}} jours jusqu'au {{date}})",
    autoRenewMonthly: 'Sauf annulation, votre abonnement sera renouvelé automatiquement chaque mois.',
    autoRenewYearly: 'Sauf annulation, votre abonnement sera renouvelé automatiquement chaque année.',
    summary: 'Résumé',
    cartSummary: 'Résumé de votre panier.',
    cart: 'Panier',
    registrantAddress: 'Adresse du titulaire',
    billingAddress: 'Adresse de facturation',
    createOrder: 'Créer la commande',
    cartEmptyWithOrders: 'Votre panier est vide. Avez-vous des <link>commandes</link> inachevées ?',
    priceFreeFun: "Rien n'est mieux que gratuit !",
    priceCoffee: "Environ le prix d'un café",
    priceBeer: "Environ le prix d'une bière",
    priceLunch: "Environ le prix d'un déjeuner simple",
    priceLunchMenu: "Environ le prix d'un menu du midi",
  },
  contact: {
    maintenance: {
      title: 'Contacts titulaires',
      description: 'Gérez les personnes ou entreprises enregistrées comme titulaires de domaines.',
      edit: 'Modifier les coordonnées',
      defaultContact: 'Par défaut pour les commandes',
      saved: 'Coordonnées mises à jour.',
      sharedNotice:
        'Cette modification met à jour le contact partagé au registre pour tous les domaines qui l’utilisent, y compris comme contact technique. Les coordonnées de facturation liées suivent le contact par défaut ; les factures existantes restent inchangées. Pour un autre titulaire, utilisez Changer de titulaire dans les paramètres du domaine.',
      linkedDomains: 'Domaines de ce titulaire :',
      sameHolder: 'Je confirme que ces coordonnées concernent la même personne ou entreprise.',
      newContactNotice: 'Créer un contact ne modifie aucun titulaire existant ni votre contact par défaut.',
      holderTitle: 'Titulaire du domaine',
      holderDescription: 'Choisissez le titulaire de ce domaine. Le domaine reste dans votre compte ; le DNS, le contact technique et la facturation restent inchangés.',
      currentHolder: 'Titulaire actuel',
      currentUnavailable: 'Les coordonnées du titulaire actuel ne sont pas disponibles. Contactez le support.',
      newHolder: 'Nouveau titulaire',
      chooseHolder: 'Choisir un contact',
      noOtherContacts: 'Aucun autre contact pour le moment. Ajoutez une adresse de titulaire pour choisir un nouveau titulaire.',
      changeHolder: 'Changer de titulaire',
      holderNotice: 'Vous changez le titulaire enregistré de {{domain}} pour le contact affiché ci-dessus.',
      holderConfirmation: 'Je suis autorisé par le titulaire actuel à effectuer ce changement et je confirme l’accord du nouveau titulaire.',
      holderSaved: 'Titulaire du domaine modifié.',
    },
    createRegistrant: 'Créer un titulaire',
    registrantType: 'Type de titulaire',
    billingType: 'Type de facturation',
    companyContact: 'Entreprise',
    companyName: "Nom de l'entreprise",
    vatId: 'N° TVA',
    registrantContact: 'Contact du titulaire',
    registrantContactRequired: "Vous n'avez pas encore créé de contact titulaire. Cela est requis par le registre.",
    registrantContactInfo: 'Vos informations de contact sont requises par le registre.',
    continueToCheckout: 'Continuer vers le paiement',
    sameAsRegistrant: "Identique à l'adresse du titulaire",
    legalNameDescription: 'Votre nom légal qui sera enregistré par le registre.',
    companyNameDescription: "Nom de l'entreprise si la facturation est pour une entreprise.",
    companyNameRegistrantDescription: "Nom de l'entreprise si le titulaire est une entreprise.",
    vatDescription: 'Numéro de TVA pour les clients professionnels (facultatif).',
    contactEmailDescription: 'Votre adresse e-mail de contact.',
    enterPhoneNumber: 'Entrer un numéro de téléphone',
    realNamePlaceholder: 'Nom complet',
    companyPlaceholder: 'Entreprise',
    vatIdPlaceholder: 'CHE-123.456.789',
    streetAndNumber: 'Rue et numéro',
    additionalAddress: "Complément d'adresse",
    state: 'Canton',
    countryOrRegion: 'Pays ou région',
    vatIdLabel: 'N° TVA :',
    addNewRegistrant: "Ajouter une nouvelle adresse d'enregistrement",
  },
  account: {
    myAccount: 'Mon compte',
    account: 'Compte',
    manageAccountSettings: 'Gérez les paramètres de votre compte.',
    orders: 'Commandes',
    domains: 'Domaines',
    websiteHosting: 'Hébergement web',
    logOut: 'Se déconnecter',
    admin: 'Admin',
    paymentMethods: 'Méthodes de paiement',
    paymentMethodsDescription: 'Gérez vos méthodes de paiement enregistrées.',
    noPaymentMethods: 'Aucune méthode de paiement enregistrée.',
    setAsDefault: 'Définir par défaut',
    defaultPaymentMethodSet: 'Méthode de paiement par défaut définie avec succès',
    paymentMethodDeleted: 'Méthode de paiement supprimée avec succès',
    expires: 'Expire {{month}}/{{year}}',
    default: 'Par défaut',
    // Avatar
    avatar: 'Avatar',
    avatarDescription: "Envie d'ajouter une photo de profil ? Vous pouvez le faire ici.",
    removeAvatar: "Supprimer l'avatar",
    uploadAvatar: 'Importer un avatar',
    avatarUpdated: 'Avatar mis à jour.',
    avatarUpdateFailed: "Impossible de mettre à jour l'avatar.",
    avatarRemoved: 'Avatar supprimé.',
    selectValidImage: 'Veuillez sélectionner un fichier image valide.',
    avatarUploadHint: 'Importez une image de 128x128 pixels maximum. Les images plus grandes seront redimensionnées.',
    // Order overview
    orderTitle: 'Commande',
    orderFrom: 'du {{date}}',
    openMenu: 'Ouvrir le menu',
    viewOrder: 'Voir la commande',
    pay: 'Payer',
    paymentStatus: 'Statut du paiement :',
    invoiceStatusPaid: 'Payé',
    invoiceStatusDraft: 'Brouillon',
    invoiceStatusOpen: 'Ouvert',
    invoiceStatusVoid: 'Annulé',
    invoiceStatusUncollectible: 'Irrécouvrable',
    discount: 'Remise :',
    total: 'Total :',
    notInitiated: '{{type}} non initiée',
    waitingForRegistry: 'En attente de communication avec le registre',
    manageOrders: 'Voir et gérer vos commandes',
    noOrdersYet: 'Pas encore de commandes',
    noOrdersDescription: "Vous n'avez pas encore passé de commande.",
    // Profile
    manageYourDomains: 'Gérez vos domaines',
    validEmailAddress: 'Veuillez entrer une adresse e-mail valide.',
    emailDescription: 'Votre adresse e-mail est utilisée pour vous connecter et recevoir des notifications et ne peut pas être modifiée.',
    displayName: "Nom d'affichage",
    displayNameDescription: "Veuillez entrer votre nom complet ou un nom d'affichage qui vous convient.",
    displayNameHint: 'Veuillez utiliser 32 caractères au maximum.',
    displayNamePlaceholder: 'Comment pouvons-nous vous appeler ?',
    recoveryEmail: 'E-mail de récupération',
    recoveryEmailDescription: "Nous n'envoyons aucun e-mail à cette adresse. Nous vous identifions par cette adresse e-mail si vous perdez l'accès à votre compte principal.",
    recoveryEmailHint: 'Veuillez utiliser une adresse e-mail valide.',
    // Delete account
    deleteAccount: 'Supprimer le compte',
    deleteAccountDescription: 'Supprimez définitivement votre compte et les données qui y sont liées. Cette action est irréversible.',
    deleteAccountBlockedDomains: 'Des domaines sont encore enregistrés chez nous. Transférez-les d’abord vers un autre registraire ou supprimez-les :',
    deleteAccountBlockedOrder: 'L’une de vos commandes est encore en cours de traitement. Veuillez réessayer une fois qu’elle sera terminée.',
    deleteAccountBlockedAdmin: 'Les comptes administrateur ne peuvent pas être supprimés ici.',
    deleteAccountBlockedImpersonation: 'Un compte ne peut pas être supprimé pendant qu’il est utilisé par délégation.',
    deleteAccountDialogTitle: 'Supprimer définitivement votre compte ?',
    deleteAccountDialogDescription: 'Cette action est irréversible. Nous supprimerons définitivement :',
    deleteAccountItemProfile: 'Votre profil, vos identifiants, vos contacts et vos moyens de paiement enregistrés',
    deleteAccountItemOrders: 'Votre panier et vos commandes impayées',
    deleteAccountItemDns: 'Les zones DNS et redirections d’URL des domaines retirés ou transférés ailleurs',
    deleteAccountItemSites: 'Vos sites web ({{count}}) avec tous leurs fichiers, déploiements et domaines personnalisés',
    deleteAccountItemSubscription: 'Votre abonnement d’hébergement prend fin immédiatement, sans remboursement',
    deleteAccountRetention: 'Les factures des paiements effectués ({{count}}) sont conservées dix ans, comme l’exige le droit suisse, puis supprimées.',
    deleteAccountConfirmLabel: 'Saisissez votre adresse e-mail pour confirmer',
    deleteAccountReauth: 'Veuillez vous déconnecter, vous reconnecter puis réessayer, afin que nous puissions confirmer votre identité.',
    deleteAccountSuccess: 'Votre compte a été supprimé.',
  },
  hosting: {
    websiteFallback: 'Site web',
    createNewWebsite: 'Créer un nouveau site web',
    createStaticSite: 'Créer un site statique',
    createStaticSiteDescription: 'Fournissez un nom et un sous-domaine pour votre site.',
    siteName: 'Nom du site',
    subdomain: 'Sous-domaine',
    siteNamePlaceholder: "Page d'accueil, portfolio, blog, etc.",
    subdomainPlaceholder: 'mon_site',
    subdomainHint: '3-32 caractères : a-z, 0-9, _',
    creating: 'Création...',
    createSite: 'Créer le site',
    siteCreated: 'Site créé',
    nameRequired: 'Le nom est requis',
    nameMaxLength: 'Le nom doit contenir au maximum 64 caractères',
    subdomainMinLength: 'Le sous-domaine doit contenir au moins 3 caractères',
    subdomainMaxLength: 'Le sous-domaine doit contenir au maximum 32 caractères',
    subdomainCharsOnly: 'Seuls a-z, 0-9 et _ sont autorisés',
    noWebsitesYet: 'Aucun site web',
    noWebsitesDescription: "Vous n'avez pas encore créé de site web. Commencez par créer votre premier site.",
    deleteSite: 'Supprimer le site',
    deleteSiteTitle: 'Supprimer "{{name}}" ?',
    deleteSiteDescription: 'Cela supprimera définitivement le site, ses domaines personnalisés et tous les fichiers déployés. Cette action est irréversible.',
    deleting: 'Suppression...',
    siteDeleted: 'Site supprimé',
    renameSiteDescription: "Seul le nom change. L'adresse de votre site reste la même.",
    siteRenamed: 'Site renommé',
    siteIconTitle: 'Icône',
    siteIconHelp: "Affichée pour ce site dans votre compte ; les visiteurs ne la voient pas. Cliquez sur l'icône pour choisir une image (500 Ko au maximum).",
    redirectsNotForParked: "Une page « Bientôt disponible » n'a pas de redirections.",
    deleteSiteSectionTitle: 'Supprimer ce site',
    publishingYourSite: 'Publication de votre site',
    savingFiles: 'Enregistrement de vos fichiers...',
    creatingNewVersion: "Création d'une nouvelle version...",
    generatingPreview: "Génération de l'aperçu...",
    makingItLive: 'Mise en ligne...',
    mayTakeFewSeconds: 'Cela peut prendre quelques secondes...',
    siteIsLive: 'Votre site est en ligne !',
    redirectingToOverview: "Redirection vers l'aperçu de votre site...",
    uploadZipArchive: 'Télécharger une archive Zip',
    uploadZipDescription: 'Téléchargez votre site statique sous forme de fichier .zip. Les fichiers sont extraits dans votre brouillon, où vous pouvez les prévisualiser et les modifier.',
    chooseZipFile: 'Veuillez choisir un fichier .zip.',
    onlyZipSupported: 'Seuls les fichiers .zip sont pris en charge.',
    uploading: 'Téléchargement...',
    uploadingWait: 'Veuillez patienter pendant le téléchargement de votre fichier',
    extractingFiles: 'Extraction des fichiers...',
    extractingToWorkspace: 'Décompression de votre fichier zip dans votre brouillon',
    uploadComplete: 'Téléchargement terminé !',
    redirectingToEditor: 'Ouverture de votre brouillon...',
    uploadFailed: 'Échec du téléchargement',
    tryAgain: 'Réessayer',
    replaceExistingFiles: 'Remplacer les fichiers existants ?',
    existingFilesCount: 'Votre brouillon contient <strong>{{count}}</strong> fichier(s) existant(s).',
    replaceAllWarning: 'Le téléchargement de ce zip <strong>remplacera tous les fichiers existants</strong>.',
    replaceAllFiles: 'Remplacer tous les fichiers',
    uploadAndExtract: 'Télécharger et extraire',
    afterExtraction: "Après l'extraction, vous pouvez prévisualiser et modifier vos fichiers avant de les publier.",
    filesExtracted: 'Fichiers extraits avec succès !',
    active: 'Actif',
    updated: 'Mis à jour le {{date}}',
    selectImageFile: 'Veuillez sélectionner un fichier image',
    imageTooLarge: "L'image doit faire moins de 500 Ko",
    faviconUpdated: 'Favicon mis à jour',
    faviconUpdateFailed: 'Échec de la mise à jour du favicon',
    clickToChangeFavicon: 'Cliquez pour changer le favicon',
    // Editor file tree
    files: 'Fichiers',
    newFile: 'Nouveau fichier',
    newFolder: 'Nouveau dossier',
    uploadFiles: 'Importer des fichiers',
    rename: 'Renommer',
    moveTo: 'Déplacer vers...',
    noFilesYet: 'Aucun fichier',
    moveFile: 'Déplacer le fichier',
    moveFileDescription: 'Sélectionnez un dossier de destination pour',
    current: '(actuel)',
    rootFolder: '/ (racine)',
    // Editor code panel
    noFileSelected: 'Aucun fichier sélectionné',
    selectFileToEdit: 'Sélectionnez un fichier pour commencer à éditer',
    modified: 'Modifié',
    download: 'Télécharger',
    imagePreview: "Aperçu de l'image",
    videoPreview: 'Aperçu de la vidéo',
    audioPreview: 'Aperçu audio',
    pdfPreview: 'Aperçu PDF',
    binaryFile: 'Fichier binaire',
    cannotPreview: 'Ce type de fichier ne peut pas être prévisualisé ici.',
    downloadFile: 'Télécharger le fichier',
    robotsTxtHint:
      "Les URL d'aperçu renvoient toujours <code class=\"bg-blue-500/20 px-1 rounded\">Disallow: /</code> pour empêcher les moteurs de recherche d'indexer le contenu d'aperçu. Votre robots.txt fonctionnera correctement une fois publié.",
    // Editor empty state
    workspaceEmpty: 'Rien ici pour le moment',
    chooseHowToStart: 'Choisissez comment vous souhaitez commencer à créer votre site',
    startFresh: 'Partir de zéro',
    startFreshDescription: 'Créer un fichier index.html vide',
    createPage: 'Créer une page',
    createPageDescription: 'Remplissez un formulaire. Sans code.',
    createPageFailed: 'Impossible de créer la page',
    advancedOptions: 'Avancé',
    uploadFilesDescription: 'Importer des fichiers et des dossiers',
    uploadZip: 'Importer un Zip',
    uploadZipShortDescription: 'Extraire une archive .zip',
    uploadWebsite: 'Importer votre site',
    uploadWebsiteDescription: 'Un zip de votre site, ou le fichier unique que votre assistant IA vous a donné.',
    chooseUploadFile: 'Choisissez un fichier .zip ou .html.',
    onlyZipOrHtmlSupported: 'Seuls les fichiers .zip et .html sont pris en charge.',
    htmlTooLarge: 'Ce fichier est trop volumineux. La limite est de {{limit}}.',
    htmlUploaded: 'Votre page a été enregistrée sous index.html.',
    uploadWebsiteHint: "Un zip est décompressé dans votre site. Un seul fichier .html devient votre page d'accueil (index.html).",
    htmlReplacesIndex: 'Ce fichier remplace votre index.html actuel. Vos autres fichiers sont conservés.',
    uploadNoFileYet: 'Pas encore de fichier ? Voyez comment en créer un avec ChatGPT ou Claude.',
    buildWithAssistant: 'Le créer avec votre assistant IA',
    buildWithAssistantDescription: "Avec ChatGPT ou Claude, puis importez le fichier unique qu'il vous donne.",
    aiCardTitle: 'Le créer avec ChatGPT ou Claude',
    aiCardDescription: 'Votre assistant IA vous pose quelques questions et crée votre page. Vous importez un seul fichier.',
    aiCardButton: 'Voir comment',
    chooseTemplate: 'Choisir un modèle',
    chooseTemplateDescription: 'Commencer avec un design élégant',
    loadFromVersion: 'Charger depuis une version',
    loadFromVersionDescription: 'Copier depuis une version existante',
    beta: 'Bêta',
    latest: 'Dernière',
    // Template gallery
    templateGalleryDescription: 'Commencez avec un modèle au design soigné et personnalisez-le selon vos besoins',
    all: 'Tous',
    applying: 'Application...',
    useThisTemplate: 'Utiliser ce modèle',
    preview: 'Aperçu',
    back: 'Retour',
    needMoreTemplates: 'Besoin de plus de modèles ?',
    useTemplate: 'Utiliser le modèle',
    templateApplied: 'Le modèle « {{name}} » a été appliqué avec succès !',
    failedToApplyTemplate: "Échec de l'application du modèle",
    // Deployments
    history: 'Historique',
    noVersionsYet: 'Aucune version pour le moment. Chaque publication enregistre une version ici.',
    publishedFromEditor: 'Publié depuis votre brouillon',
    fileUpload: 'Import de fichiers',
    zipUpload: 'Import Zip',
    live: 'En ligne',
    updatedTime: 'Mis à jour :',
    // Deployment page actions
    version: 'Version',
    failedToRestore: 'Impossible de restaurer cette version.',
    versionNowLive: 'La version est maintenant en ligne !',
    failedToEditCopy: 'Impossible de copier cette version pour la modifier.',
    editCopyReady: 'Vous modifiez maintenant une copie de cette version.',
    versionDeleted: 'Version supprimée',
    failedToDeleteVersion: 'Échec de la suppression de la version.',
    previewVersion: 'Aperçu de la version',
    editCopy: 'Modifier une copie de cette version',
    replaceDraftTitle: 'Remplacer votre brouillon ?',
    replaceDraftDescription: 'Tous les fichiers de votre brouillon seront remplacés par cette version. Les modifications non publiées seront perdues.',
    deleteVersion: 'Supprimer la version',
    deleteVersionTitle: 'Supprimer cette version ?',
    deleteVersionDescription: 'Cela supprimera définitivement cette version et ses fichiers stockés. Cette action est irréversible.',
    restoring: 'Restauration...',
    restoreVersion: 'Restaurer cette version',
    downloadVersion: 'Télécharger cette version (zip)',
    // Share draft and download (Edit toolbar)
    downloadFiles: 'Télécharger les fichiers',
    shareDraft: 'Partager le brouillon',
    shareDraftTitle: 'Partager votre brouillon',
    shareDraftDescription: "Toute personne disposant du lien peut voir votre brouillon jusqu'à l'expiration du lien. Il n'est mis sur Internet sous votre domaine que lorsque vous publiez.",
    shareDraftDuration: 'Le lien fonctionne pendant',
    shareDraft1d: '1 jour',
    shareDraft7d: '7 jours',
    shareDraft30d: '30 jours',
    shareDraftCreate: 'Créer le lien',
    shareDraftLink: 'Lien vers votre brouillon',
    shareDraftExpires: 'Expire le {{date}}',
    shareDraftCopyManually: 'Le lien est sélectionné : copiez-le avec Ctrl+C ou ⌘C.',
    copyLink: 'Copier',
    copied: 'Copié',
    stopSharing: 'Arrêter le partage',
    stopSharingConfirm: "Tous les liens créés jusqu'ici cesseront de fonctionner.",
    stopSharingDone: 'Vos liens de brouillon ne fonctionnent plus.',
    // Deployment overview
    previewUrl: "URL d'aperçu",
    domains: 'Domaines',
    createdVia: 'Créé via',
    editor: 'Modifié en ligne',
    git: 'Git',
    madeLive: 'Mis en ligne',
    duration: 'Durée',
    size: 'Taille',
    buildFailed: 'Échec de la compilation',
    versionPreview: 'Aperçu de la version',
    openPreview: "Ouvrir l'aperçu",
    currentlyLive: 'Actuellement en ligne',
    connectedDomains: 'Domaines connectés',
    // Deployment status
    statusReady: 'Prêt',
    statusFailed: 'Échoué',
    statusBuilding: 'En cours de compilation',
    statusUploaded: 'Importé',
    statusPending: 'En attente',
    // Empty deployment
    versionNotFound: 'Version introuvable',
    versionNotFoundDescription: "Cette version n'a pas pu être chargée. Elle a peut-être été supprimée ou une erreur s'est produite.",
    // Performance panel
    runAnalysis: "Lancer l'analyse",
    analyzing: 'Analyse...',
    screenshot: "Capture d'écran",
    performance: 'Performance',
    // Files upload
    uploadFilesTitle: 'Importer des fichiers',
    uploadFilesDialogDescription: 'Importez des fichiers directement dans votre brouillon. Vous pouvez les prévisualiser et les modifier avant de les publier.',
    selectAtLeastOneFile: 'Veuillez sélectionner au moins un fichier.',
    uploadedFilesSuccess: '{{count}} fichier(s) importé(s) avec succès !',
    uploadFailedRetry: "L'import a échoué. Veuillez réessayer.",
    replaceExistingFilesQuestion: 'Remplacer les fichiers existants ?',
    existingFileCount: 'Votre brouillon contient <strong>{{count}}</strong> fichier(s) existant(s).',
    uploadWillReplaceAll: "L'import <strong>remplacera tous les fichiers existants</strong>.",
    clearingWorkspace: 'Vidage de votre brouillon...',
    removingExistingFiles: 'Suppression des fichiers existants',
    uploadingProgress: 'Import en cours... ({{current}}/{{total}})',
    pleaseWaitUploading: "Veuillez patienter pendant l'import de vos fichiers",
    uploadLimitsExceeded: "Limites d'import dépassées",
    uploadLimitsDescription: 'Les fichiers sélectionnés dépassent les limites pour les imports de fichiers individuels.',
    tooManyFiles: 'Trop de fichiers :',
    youSelected: 'Vous avez sélectionné {{count}} fichiers, mais la limite est de {{max}} fichiers.',
    filesExceedSize: '{{count}} fichier(s) dépassent la limite de taille de {{limit}} :',
    andMore: '...et {{count}} de plus',
    useZipUpload: "Utiliser l'import ZIP à la place",
    useZipUploadDescription:
      "Pour importer de nombreux fichiers ou des fichiers volumineux, compressez votre projet dans un fichier <strong>.zip</strong> et utilisez l'option <strong>Import Zip</strong>. C'est plus rapide et prend en charge les projets plus volumineux.",
    goBack: 'Retour',
    selectFiles: 'Sélectionner des fichiers',
    selectFolder: 'Sélectionner un dossier',
    filesSelected: '{{count}} fichier(s) sélectionné(s)',
    clearAll: 'Tout effacer',
    useZipForLarger: "<strong>Utilisez l'import ZIP</strong> pour les projets plus volumineux.",
    selectFilesToUpload: 'Sélectionnez des fichiers ou un dossier à importer dans votre brouillon',
    fileLimitsInfo: 'Limite : {{maxFiles}} fichiers, {{maxSize}} par fichier. Pour les imports plus volumineux, utilisez le ZIP.',
    uploadCount: 'Importer {{count}} fichier(s)',
    upload: 'Importer',
    // Static site domains
    domainAdded: 'Domaine ajouté',
    domainAddedWithRedirect: 'www.{{domain}} ajouté. {{domain}} sera redirigé automatiquement vers www.{{domain}}.',
    upgradeToAddDomains: 'Passez à un plan supérieur pour ajouter des domaines personnalisés',
    upgradeToAddDomainsWithCount: 'Passez à un plan supérieur pour ajouter des domaines ({{used}}/{{limit}})',
    addDomain: 'Ajouter un domaine',
    addDomainWithCount: 'Ajouter un domaine ({{used}}/{{limit}})',
    addADomain: 'Ajouter un domaine',
    enterDomainToMap: 'Entrez le domaine à associer à ce site.',
    domainSource: 'Source du domaine',
    buyADomain: 'Acheter un domaine',
    myDomains: 'Mes domaines',
    thirdPartyDomains: 'Domaines tiers',
    myDomainsDnsHint: 'Nous gérerons automatiquement le DNS et le certificat SSL pour vous.',
    thirdPartyDnsHint: "Après l'ajout du domaine, nous vous indiquons les enregistrements DNS à créer chez votre fournisseur DNS.",
    subdomainOptional: 'Sous-domaine (facultatif)',
    selectADomain: 'Sélectionner un domaine',
    noDomainsWithUs: "Vous n'avez pas encore de domaine chez nous.",
    saving: 'Enregistrement\u2026',
    addDomainButton: 'Ajouter le domaine',
    // Delete domain
    removeDomainTitle: 'Supprimer « {{hostname}} » ?',
    removeDomainMapping: "Cela supprimera l'association du domaine avec ce site. Vous pourrez l'ajouter à nouveau ultérieurement.",
    domainRemoved: 'Domaine supprimé',
    removing: 'Suppression\u2026',
    // Analytics
    analytics: 'Statistiques',
    days7: '7 jours',
    days30: '30 jours',
    days90: '90 jours',
    visitors: 'Visiteurs',
    pageViews: 'Pages vues',
    bandwidth: 'Bande passante',
    visitorsAndPageViews: 'Visiteurs et pages vues',
    topPages: 'Pages les plus consultées',
    views: 'Vues',
    topReferrers: 'Principaux référents',
    countries: 'Pays',
    devices: 'Appareils',
    browsers: 'Navigateurs',
    noData: 'Aucune donnée',
    noPageData: 'Aucune donnée de page',
    noReferrerData: 'Aucune donnée de référent',
    noCountryData: 'Aucune donnée de pays',
    vsPrevious: 'vs précédent',
    noAnalyticsYet: 'Aucune donnée statistique pour le moment',
    noAnalyticsDescription: 'Les données statistiques apparaîtront ici une fois que votre site commencera à recevoir du trafic.',
    // Static sites page
    hostFastSecure: 'Hébergez des sites web rapides et sécurisés sans serveurs.',
    upgradeToCreateMore: 'Passez à un plan supérieur pour en créer plus',
    // Editor page
    takingLonger: 'Cela prend plus de temps que prévu',
    uploadRunningFor: "L'import est en cours depuis {{time}}.",
    extractionRunningFor: "L'extraction est en cours depuis {{time}}.",
    cancelAndRetry: 'Vous pouvez annuler et réessayer avec un fichier plus petit.',
    cancelStartOver: 'Annuler & recommencer',
    pleaseWaitProcessing: 'Veuillez patienter pendant le traitement de vos fichiers',
    elapsed: 'Écoulé : {{time}}',
    extractionFailed: 'Extraction échouée',
    errorProcessingFiles: 'Une erreur est survenue lors du traitement de vos fichiers.',
    troubleshootingTips: 'Conseils de dépannage :',
    tipZipNotCorrupted: "Assurez-vous que le fichier ZIP n'est pas corrompu",
    tipSmallerZip: 'Essayez avec un fichier ZIP plus petit (moins de 100 Mo)',
    tipNoSpecialChars: 'Évitez les caractères spéciaux dans les noms de fichiers/dossiers',
    tipValidFiles: 'Assurez-vous que le ZIP contient des fichiers de site web statique valides',
    unsavedChangesTitle: 'Abandonner les modifications non enregistrées ?',
    unsavedChangesDiscard: "Vos modifications de ce fichier n'ont pas été enregistrées et seront perdues.",
    discardChanges: 'Abandonner les modifications',
    fileCountLabel: '{{count}} fichier(s)',
    fromVersion: 'Depuis la version #{{version}}',
    deleteFileConfirm: 'Supprimer "{{path}}" ?',
    deleteFileDescription: 'Il sera retiré de votre brouillon. Les versions publiées ne sont pas affectées.',
    tooManyFilesInline: 'Trop de fichiers ({{count}}/{{max}}).',
    filesExceedInline: '{{count}} fichier(s) dépassent {{limit}}.',
    andMoreFiles: '...et {{count}} fichiers de plus',
    failedToLoadFile: 'Échec du chargement du fichier',
    failedToLoadPreview: "Échec du chargement de l'aperçu du fichier",
    fileSaved: 'Fichier enregistré',
    failedToSaveFile: "Échec de l'enregistrement du fichier",
    failedToCreateFile: 'Échec de la création du fichier',
    folderCreated: 'Dossier créé',
    failedToCreateFolder: 'Échec de la création du dossier',
    fileDeleted: 'Fichier supprimé',
    failedToDeleteFile: 'Échec de la suppression du fichier',
    fileRenamed: 'Fichier renommé',
    failedToRenameFile: 'Échec du renommage du fichier',
    failedToCreateStarter: 'Échec de la création du fichier de démarrage',
    workspaceInitialized: 'Brouillon copié depuis la version',
    failedToLoadDeployment: 'Échec du chargement depuis le déploiement',
    publishStoppedSaveFailed: "Vos modifications n'ont pas pu être enregistrées, rien n'a donc été publié. Veuillez réessayer.",
    failedToPublish: 'Échec de la publication',
    workspaceCleared: 'Brouillon vidé',
    failedToClearWorkspace: 'Échec du vidage de votre brouillon',
    startOver: 'Recommencer',
    startOverTitle: 'Recommencer de zéro ?',
    startOverDescription: 'Cela supprimera tous les fichiers de votre brouillon pour que vous puissiez repartir à zéro. Vos versions publiées ne seront pas affectées.',
    publish: 'Publier',
    publishing: 'Publication...',
    publishYourWebsite: 'Publiez votre site web',
    filesTooLarge: 'Fichiers trop volumineux',
    uploadMaxFiles: "Vous pouvez importer jusqu'à {{max}} fichiers à la fois.",
    useZipForBulk: "Utilisez l'import ZIP pour les fichiers en masse",
    useZipForBulkDescription:
      "Pour importer de nombreux fichiers ou des fichiers volumineux, utilisez plutôt l'option Import ZIP. Allez à l'aperçu du site et utilisez « Import ZIP » pour importer l'ensemble de votre projet en une seule fois.",
    goToOverview: "Aller à l'aperçu",
    // Site overview page
    visitSite: 'Visiter le site',
    draft: 'Brouillon',
    liveUrl: 'URL en ligne',
    noCustomDomain: 'Aucun domaine personnalisé configuré.',
    addOne: 'En ajouter un',
    moreDomains: '+{{count}} domaine(s) supplémentaire(s)',
    previewOnly: 'Aperçu uniquement',
    previewOnlyDescription: 'Seules les personnes disposant du lien de prévisualisation peuvent voir ce site. Publiez-le pour obtenir une adresse publique.',
    viewLive: 'Voir en ligne',
    getStarted: 'Commencer',
    getStartedDraftDescription: 'Créez votre page, puis choisissez un plan pour la publier.',
    getStartedDescription: "Rien n'est encore publié. Créez votre page, puis publiez-la.",
    editYourPage: 'Modifier votre page',
    sitePreview: 'Aperçu du site',
    historyLink_one: 'Historique ({{count}} version)',
    historyLink_other: 'Historique ({{count}} versions)',
    visitorsLast30Days: 'Visiteurs, 30 derniers jours',
    visitorsLast30DaysCount: 'Visiteurs, 30 derniers jours : {{count}}',
    versionCount_one: '{{count}} version',
    versionCount_other: '{{count}} versions',
    visitorsLast30DaysValue: '{{count}} sur les 30 derniers jours',
    nextFinishTitle: 'Terminez votre page',
    nextFinishText: "Votre page n'est pas encore sur Internet. Terminez-la, puis cliquez sur Publier.",
    nextPublishTitle: 'Publiez votre page',
    nextPublishText: 'Vous pouvez partager votre brouillon avec son lien de prévisualisation. Choisissez un plan pour le mettre sur Internet.',
    nextConnectTitle: 'Connectez votre domaine',
    nextConnectText: 'Votre page est en ligne sur {{address}}. Connectez votre propre domaine pour que les visiteurs la trouvent sous votre nom.',
    nextFinishConnectingTitle: 'Terminez la connexion de {{hostname}}',
    nextFinishConnectingText: "Le domaine attend ses enregistrements DNS. L'onglet Domaines indique ce qu'il faut configurer.",
    showDnsRecords: 'Afficher les enregistrements DNS',
    nextReplaceParkedTitle: 'Remplacer par une vraie page',
    nextReplaceParkedText: 'Un vrai site web nécessite un plan.',
    nextReplaceParkedPlanText: 'Transformez votre page « Bientôt disponible » en une vraie page que vous modifiez avec un formulaire.',
    replaceParkedButton: 'Remplacer',
    replaceParkedDialogTitle: 'Remplacer par une vraie page ?',
    replaceParkedDialogText: 'Votre page « Bientôt disponible » devient une vraie page que vous modifiez avec un formulaire. Elle compte dans votre plan et est mise en ligne immédiatement.',
    replaceParkedConverting: 'Remplacement...',
    seePlans: 'Voir les plans',
    // Coming-soon page on a domain registered at YWT
    putPageOnDomainTitle: 'Mettre une page sur {{domain}}',
    putPageOnDomainText: 'Montrez une page à vos visiteurs pendant que vous créez votre site web. Gratuit pour les domaines enregistrés chez YWT.',
    putPageOnDomainButton: 'Créer la page',
    putPageDialogTitle: 'Une page « Bientôt disponible » pour {{domain}}',
    putPageDialogDescription: 'Les visiteurs de {{domain}} voient cette page jusqu’à ce que votre site web soit prêt. Vous pouvez la modifier à tout moment.',
    putItOnline: 'Mettre en ligne',
    puttingOnline: 'Mise en ligne...',
    parkedHeadline: 'Titre',
    parkedMessage: 'Message',
    parkedContactEmail: 'E-mail de contact (facultatif)',
    parkedDefaultMessage: 'Nous préparons quelque chose de spécial.',
    parkedHeadlineRequired: 'Saisissez un titre.',
    parkedMessageRequired: 'Saisissez un message.',
    parkedTooLong: '{{max}} caractères au maximum.',
    parkedEmailInvalid: 'Saisissez une adresse e-mail valide.',
    parkedEditTitle: 'Votre page « Bientôt disponible »',
    parkedEditDescription: 'Les visiteurs de {{domain}} voient cette page. L’enregistrement met vos modifications en ligne.',
    parkedDomainsNote: 'Cette page s’affiche sur {{domain}} et www.{{domain}}.',
    comingSoonBadge: 'Page « Bientôt disponible »',
    // Business page (a one-page website made from a form)
    businessEditTitle: 'Votre page',
    businessEditDescription: 'Remplissez le formulaire ; l’aperçu montre votre page. « Enregistrer » garde vos modifications, « Publier » les met sur Internet.',
    businessName: 'Nom',
    businessTagline: 'Slogan (facultatif)',
    businessAbout: 'À propos (facultatif)',
    businessServices: 'Prestations (facultatif)',
    businessService: 'Prestation {{n}}',
    businessRemoveService: 'Supprimer la prestation {{n}}',
    businessAddService: 'Ajouter une prestation',
    businessHours: 'Heures d’ouverture (facultatif)',
    businessPhone: 'Téléphone (facultatif)',
    businessEmail: 'E-mail (facultatif)',
    businessAddress: 'Adresse (facultatif)',
    businessTheme: 'Couleurs',
    businessThemeLight: 'Clair',
    businessThemeDark: 'Sombre',
    businessThemeWarm: 'Chaud',
    businessThemeCool: 'Frais',
    businessNameRequired: 'Saisissez un nom.',
    businessPhoneInvalid: 'Utilisez uniquement des chiffres, des espaces et + ( ) -.',
    businessPhoto: 'Photo (facultatif)',
    businessPhotoHint: 'JPEG, PNG ou WebP, jusqu’à 2 Mo. Elle est enregistrée immédiatement.',
    businessPhotoShown: 'Votre photo figure en haut de la page.',
    businessPhotoChoose: 'Choisir une photo',
    businessPhotoReplace: 'Remplacer la photo',
    businessPhotoRemove: 'Supprimer la photo',
    businessPhotoWrongType: 'Choisissez une image JPEG, PNG ou WebP.',
    businessPhotoTooLarge: 'La photo dépasse 2 Mo.',
    businessPhotoFailed: 'Impossible d’enregistrer la photo',
    businessPreviewTitle: 'Aperçu de votre page',
    businessPreviewEmpty: 'L’aperçu s’affiche ici.',
    businessPreviewUpdating: 'Mise à jour...',
    businessSaved: 'Page enregistrée',
    businessSaveFailed: 'Échec de l’enregistrement de la page',
    unsavedPageDiscard: 'Vos modifications de cette page n’ont pas été enregistrées et seront perdues.',
    businessPageBadge: 'Page',
    // Custom domains page
    primaryDomainUpdated: 'Domaine principal mis à jour',
    failedToSetPrimary: 'Échec de la définition du domaine principal',
    domainConnected: 'Connecté',
    invalidConfiguration: 'Configuration invalide',
    pendingDns: 'DNS en attente',
    customDomains: 'Domaines personnalisés',
    customDomainsDescription: 'Connectez votre propre domaine à ce site web',
    notLiveYetWarning: "Ce site web n'est pas encore en ligne. Les domaines suivants ne seront pas effectifs.",
    noCustomDomainsYet: 'Aucun domaine personnalisé pour le moment.',
    primary: 'PRINCIPAL',
    refreshStatus: 'Actualiser le statut',
    setAsPrimary: 'Définir comme principal',
    setAsPrimaryNotConnected: '(pas encore connecté)',
    setAsPrimaryNotForParked: '(pas pour une page « Bientôt disponible »)',
    primaryLabel: '(Principal)',
    dnsConfigRequired: 'Configuration DNS requise',
    dnsConfigDescription: "Ajoutez l'enregistrement DNS suivant chez votre fournisseur de domaine pour vérifier la propriété.",
    dnsPropagationNote:
      "Les modifications DNS prennent généralement environ une demi-heure, mais peuvent nécessiter jusqu'à 48 heures pour se propager. Nous vérifions automatiquement toutes les 30 secondes.",
    // Hosting plans page
    plansTitle: 'Hébergement de sites statiques',
    plansSubtitle: 'Pas de configuration complexe. Pas de frais cachés. Un hébergement simple, rapide, sécurisé et fiable.',
    salesClosedTitle: 'L’hébergement statique n’est plus proposé',
    salesClosedDescription: 'L’hébergement statique n’est plus proposé aux nouveaux clients. Les abonnements existants se poursuivent jusqu’à leur date de fin.',
    salesClosedLearnMore: 'À propos de l’hébergement statique',
    siteLimitReached: 'Limite de sites atteinte',
    customDomainLimitReached: 'Limite de domaines personnalisés atteinte',
    tierPlan: 'Plan {{tier}}',
    alreadySubscribed: "Vous êtes déjà abonné à l'hébergement statique.",
    manageYourPlan: 'Gérer votre plan',
    featureHttpsTitle: 'HTTPS inclus',
    featureHttpsDesc: 'Aucun certificat à gérer. Sécurisé par défaut.',
    featureFastTitle: 'Chargement rapide',
    featureFastDesc: 'Les pages statiques se chargent vite, sans code serveur à attendre.',
    featureDomainsTitle: 'Domaines personnalisés',
    featureDomainsDesc: 'Configuration facile pour vos propres domaines.',
    featureSwissTitle: 'Centre de données suisse',
    featureSwissDesc: "Les données restent dans l'infrastructure suisse.",
    billingMonthly: 'Mensuel',
    billingYearly: 'Annuel',
    savePercent: 'Économisez {{percent}}%',
    billedMonthly: 'facturé mensuellement',
    billedYearlyFor: 'facturé annuellement pour',
    noSubscriptionRequired: 'aucun abonnement ni paiement requis',
    freeTrialDesc: 'Essayez et construisez avant de prendre votre décision.',
    startForFree: 'Commencer gratuitement',
    oneWebsite: '1 site web',
    embeddedEditor: 'Éditeur de code intégré',
    fileZipUpload: 'Téléchargement de fichiers/Zip',
    previewLinkFeature: 'Lien de prévisualisation à partager',
    publishNeedsPlanFeature: 'La publication nécessite un plan',
    noCustomDomainFeature: 'Pas de domaine personnalisé',
    publishOnStarter: 'Publiez votre site avec un domaine personnalisé sur Starter.',
    popularLabel: 'Populaire',
    starterDesc: 'Tout ce dont vous avez besoin pour un vrai site web.',
    yourCurrentPlan: 'Votre plan actuel',
    downgradeToStarter: 'Rétrograder vers Starter',
    getStarter: 'Choisir Starter',
    featuresFromFree: 'Fonctionnalités du plan gratuit',
    oneCustomDomain: '1 domaine personnalisé',
    customDomainTooltip: "Utilisez votre propre domaine (ex. votrenom.ch). L'enregistrement du domaine n'est pas inclus.",
    websiteAnalysis: 'Analyse et surveillance du site web',
    fastSecureDeliveryFeature: 'Diffusion rapide et sécurisée avec HTTPS',
    emailSupportFeature: 'Support par e-mail',
    fourteenDayGuarantee: 'Garantie de remboursement de 14 jours',
    perfectForPersonal: 'Parfait pour les sites personnels et les petites entreprises.',
    businessDesc: 'Pour plusieurs sites web et une utilisation plus élevée.',
    upgradeToBusinessButton: 'Passer à Business',
    chooseBusiness: 'Choisir Business',
    featuresFromStarter: 'Fonctionnalités du plan Starter',
    upToFiveWebsites: "Jusqu'à 5 sites web",
    upToTenDomains: "Jusqu'à 10 domaines personnalisés",
    higherTraffic: 'Trafic plus élevé',
    prioritySupport: 'Support par e-mail prioritaire',
    thirtyDayGuarantee: 'Garantie de remboursement de 30 jours',
    needMoreWebsites: 'Besoin de plus de 5 sites web ? Parlons-en.',
    moneyBackTitle: "Garantie de remboursement jusqu'à 30 jours",
    moneyBackDesc: "Pendant la période de garantie de remboursement, si vous n'êtes pas satisfait de notre service, nous vous rembourserons. Sans aucune question.",
    whatsIncludedAll: 'Ce qui est inclus dans tous les plans',
    httpsIncludedFeature: 'HTTPS inclus',
    managedDns: 'DNS géré',
    noServerMaintenance: 'Aucune maintenance de serveur',
    fairUseTraffic: 'Trafic en usage raisonnable',
    noHiddenFeesFeature: 'Aucun frais caché',
    fairUseNote: "L'usage raisonnable s'applique. Nous vous contacterons avant que toute limite ne soit atteinte.",
    faqWhatIsStaticQ: "Qu'est-ce que l'hébergement de site web statique ?",
    faqWhatIsStaticA:
      "L'hébergement statique sert des fichiers HTML, CSS et JavaScript pré-construits directement aux visiteurs. C'est parfait pour les pages d'accueil, les portfolios, la documentation, les blogs construits avec des outils comme Hugo, Jekyll ou Next.js (export statique), et les applications monopage (React, Vue, etc.).",
    faqDynamicQ: 'Puis-je exécuter du contenu dynamique comme PHP ou des bases de données ?',
    faqDynamicA:
      "Non. L'hébergement statique ne sert que des fichiers \u2014 il n'y a pas de traitement côté serveur. Si vous avez besoin de PHP, de backends Node.js ou de bases de données, vous aurez besoin d'une autre solution d'hébergement. Cependant, vous pouvez utiliser des API externes et des fonctions serverless pour les fonctionnalités dynamiques.",
    faqCustomDomainQ: 'Comment connecter mon propre domaine ?',
    faqCustomDomainA:
      "Après avoir créé votre site web, allez dans l'onglet Domaines et ajoutez votre domaine. Nous vous fournirons les enregistrements DNS à configurer. Si votre domaine est enregistré chez nous, le DNS est configuré automatiquement. Les certificats HTTPS sont émis automatiquement une fois le DNS configuré.",
    faqDeployQ: 'Comment déployer mon site web ?',
    faqDeployA: 'Modifiez votre page directement dans votre navigateur, importez des fichiers ou une archive ZIP, puis cliquez sur Publier. Tout se trouve dans le tableau de bord de votre site.',
    faqHttpsQ: 'Le HTTPS/SSL est-il inclus ?',
    faqHttpsA:
      'Oui ! Tous les sites web obtiennent automatiquement des certificats HTTPS gratuits. Une fois le DNS de votre domaine correctement configuré, nous émettons et renouvelons les certificats pour vous \u2014 aucune étape manuelle requise.',
    faqVatQ: 'Comment la TVA est-elle gérée ?',
    faqVatA:
      "Le prix affiché est le même pour tout le monde. Les clients suisses ont 8,1% de TVA incluse dans le prix (indiquée sur les factures). Les clients hors de Suisse paient le même montant mais la TVA suisse ne s'applique pas.",
    faqRefundQ: "Qu'est-ce que la garantie de remboursement ?",
    faqRefundA:
      "Si vous n'êtes pas satisfait pendant la période de garantie (14 jours pour Starter, 30 jours pour Business), contactez-nous et nous procéderons à un remboursement intégral \u2014 sans poser de questions.",
    faqFreePlanQ: 'Puis-je utiliser le plan gratuit pour construire mon site web ?',
    faqFreePlanA: 'Oui. Avec le plan gratuit, vous pouvez créer votre page et la partager avec un lien de prévisualisation. Pour la publier sur Internet sous votre domaine, il faut un plan.',
    faqUpgradeQ: 'Puis-je mettre à niveau mon plan plus tard ?',
    faqUpgradeA: 'Oui. Vous pouvez passer de Starter à Business à tout moment. Nous calculerons la différence au prorata pour la période restante de votre abonnement.',
    faqFairUsageQ: "Qu'est-ce que la politique d'usage raisonnable ?",
    faqFairUsageA:
      "Nous n'imposons pas de limites strictes de trafic, mais nous attendons une utilisation normale du site web. Si votre site connaît des pics inhabituels (par ex. trafic viral ou abus), nous vous contacterons avant de prendre toute mesure. La grande majorité des sites web n'approchent jamais aucune limite.",
    faqDataLocationQ: 'Où mon site web est-il stocké ?',
    faqDataLocationA: 'Les fichiers de votre site sont stockés dans une infrastructure située à Zurich, en Suisse.',
    faqAnalyticsQ: 'Proposez-vous des analyses de site web ?',
    faqAnalyticsA:
      "Oui ! Nous fournissons des analyses de performance qui montrent la vitesse de chargement de votre site web, les Core Web Vitals et des suggestions d'optimisation. Ainsi que des analyses de visiteurs comme les pages vues, les visiteurs, les appareils, les navigateurs, les référents, les pays, etc.",
    faqSupportQ: "Comment obtenir de l'aide ?",
    faqSupportA: "Envoyez-nous un e-mail à <email>support@ywt.ch</email>. Les clients du plan Business bénéficient d'un support prioritaire avec des temps de réponse plus rapides.",
    // Path redirects
    redirectsTitle: 'Redirections de chemin',
    redirectsDescription: 'Redirigez un chemin spécifique de votre site vers une autre URL, sur ce site ou ailleurs.',
    redirectsHowItWorksTitle: 'Fonctionnement des redirections de chemin',
    redirectsHowItWorksBody:
      "Les règles correspondent exactement au chemin ('/blog' correspond aussi à '/blog/') et sont appliquées avant les fichiers de votre site — une règle s'applique même si un fichier existe encore à ce chemin. Les modifications sont actives en une minute environ.",
    redirectFromLabel: 'Chemin source',
    redirectToLabel: 'Rediriger vers',
    redirectFromHint: "Doit être un chemin commençant par '/', sans paramètres ni espaces",
    redirectToHint: "Saisissez une URL absolue (https://…) ou un chemin de ce site commençant par '/'",
    addRedirect: 'Ajouter une redirection',
    updateRedirect: 'Mettre à jour la redirection',
    editRedirect: 'Modifier la redirection',
    currentRedirects: 'Redirections actuelles',
    noRedirects: 'Aucune redirection configurée pour le moment.',
    redirectPermanent: 'Permanente ({{code}})',
    redirectTemporary: 'Temporaire ({{code}})',
    redirectAdded: 'Redirection ajoutée',
    redirectUpdated: 'Redirection mise à jour',
    redirectRemoved: 'Redirection supprimée',
  },
  aiAssistant: {
    title: 'Créez votre site web avec votre assistant IA',
    pitch:
      "Utilisez le ChatGPT ou le Claude que vous avez déjà : il vous pose des questions, crée votre page, et vous importez un seul fichier. L'essai est gratuit ; vous ne payez que pour mettre le site en ligne.",
    step1Title: 'Copiez cette ligne et collez-la dans votre assistant',
    oneLiner: 'Lis {{url}} et aide-moi à créer mon site web.',
    step1Description: 'Votre assistant lit nos instructions sur cette page. Rien à installer, rien à connecter.',
    copy: 'Copier',
    copiedShort: 'Copié',
    copied: 'La ligne est dans votre presse-papiers. Collez-la dans votre assistant.',
    copyFailed: 'Copie impossible. Sélectionnez la ligne et copiez-la à la main.',
    step2Title: "Répondez à ses questions et téléchargez le fichier index.html qu'il vous donne",
    step2Description:
      "Il demande à quoi sert le site, votre nom, ce que vous proposez et comment vous joindre, puis crée la page et vous la montre. Demandez des changements jusqu'à ce qu'elle vous plaise, puis téléchargez le fichier.",
    step3Title: 'Créez un site chez YWT et importez ce fichier',
    step3Description:
      "Sous Hébergement web, créez un site et choisissez «Le créer avec votre assistant IA» dans l'onglet «Modifier». Vous pouvez l'afficher et partager un lien de brouillon tout de suite. Pour le mettre sur votre domaine, publiez-le avec le plan Starter.",
    goToHosting: 'Hébergement web',
    seePlans: 'Voir les plans',
    tabsTitle: 'Où la coller',
    chatgptOpen: "Ouvrez ChatGPT (chatgpt.com ou l'application de bureau) et commencez une nouvelle discussion.",
    claudeOpen: "Ouvrez Claude (claude.ai ou l'application de bureau) et commencez une nouvelle discussion.",
    pasteAndEnter: 'Collez la ligne et appuyez sur Entrée.',
    noBrowsingHint: "S'il dit qu'il ne peut pas ouvrir la page, utilisez «Copier le prompt complet» ci-dessous et collez-le à la place.",
    chatgptResult: 'La page terminée arrive sous forme de fichier à télécharger. Enregistrez-la sous index.html.',
    claudeResult: 'La page terminée apparaît comme un artefact à côté de la discussion. Utilisez son bouton de téléchargement et enregistrez-la sous index.html.',
    fullPromptTitle: 'Votre assistant ne peut pas ouvrir de liens ?',
    fullPromptDescription: 'Copiez plutôt le prompt de départ complet (en anglais) et collez-le dans la discussion. Il fonctionne de la même façon.',
    copyFullPrompt: 'Copier le prompt complet',
    fullPromptCopied: 'Le prompt complet est dans votre presse-papiers. Collez-le dans votre assistant.',
    fullPromptFailed: 'Impossible de charger le prompt. Nous avons ouvert la page de documentation dans un nouvel onglet ; copiez-le depuis là.',
    openDocs: 'Le lire dans la documentation',
    faqPhotosQ: 'Et les photos ?',
    faqPhotosA: "Votre assistant ne voit pas vos photos, il laisse donc un emplacement réservé à chaque endroit. Après avoir importé votre page, ajoutez les photos dans l'éditeur, onglet «Modifier».",
    faqChangesQ: 'Comment modifier quelque chose plus tard ?',
    faqChangesA: "Téléchargez votre index.html depuis l'onglet «Modifier», donnez-le à votre assistant et dites ce qui doit changer. Importez ensuite le nouveau fichier de la même façon.",
    faqCostQ: 'Combien ça coûte ?',
    faqCostA: 'Créer la page et partager un lien de brouillon est gratuit, tout comme votre compte YWT. Pour la publier sur Internet, sur votre propre domaine, il faut le plan Starter.',
  },
  consent: {
    title: "Cookies d'analyse",
    body: "Pouvons-nous utiliser des cookies d'analyse ? Ils nous aident à voir ce qui fonctionne sur ce site et ce qui ne fonctionne pas.",
    accept: "D'accord",
    decline: 'Non merci',
    settings: 'Paramètres des cookies',
  },
  footer: {
    productOf: 'est un produit de Cuspar GmbH, \u00a9 Cuspar GmbH {{year}}',
    swissMadeSoftware: 'Swiss Made Software',
  },
  admin: {
    domainSynced: '{{domain}} synchronisé',
    domainsSynced: '{{count}} domaine(s) synchronisé(s)',
    filterDomainsPlaceholder: 'Filtrer par domaine ou e-mail du client…',
    domainsShown: '{{shown}} / {{total}}',
    syncAllShown: 'Synchroniser tous les domaines affichés ({{count}})',
    sync: 'Synchroniser',
    domains: 'Domaines',
    users: 'Utilisateurs',
    subscriptions: "Abonnements d'hébergement statique",
    user: 'Utilisateur',
    registrar: 'Registraire',
    expires: 'Expire',
    autoRenew: 'Renouvellement automatique',
    ywtDns: 'YWT DNS',
    deleted: 'Supprimé',
    renewals: 'Renouvellements',
    urlForwarding: "Redirection d'URL",
    rules: '{{count}} règle(s)',
    staticSite: 'Site statique',
    orders: 'Commandes',
    websites: 'Sites web',
    subscription: 'Abonnement',
    none: 'Aucun',
    impersonate: 'Se faire passer pour',
    deleteUser: 'Supprimer le compte',
    deleteUserTitle: 'Supprimer le compte de {{email}} ?',
    deleteUserDescription:
      'Cette action est irréversible. Le profil, les identifiants, les contacts, les moyens de paiement enregistrés, le panier, les commandes impayées, les sites web ({{sites}}), les zones DNS et les redirections d’URL du client sont définitivement supprimés, et le client en est informé par e-mail.',
    deleteUserSubscription: 'L’abonnement d’hébergement actif prend fin immédiatement, sans remboursement.',
    deleteUserRetention: 'Les commandes payées ({{count}}) sont conservées dix ans, comme l’exige le droit suisse.',
    deleteUserBlockedDomains: 'Ce client a encore des domaines enregistrés chez nous. Ils doivent d’abord être transférés ailleurs ou supprimés :',
    deleteUserBlockedOrder: 'L’une des commandes du client est encore en cours de traitement. Réessayez une fois qu’elle sera terminée.',
    deleteUserBlockedAdmin: 'Les comptes administrateur ne peuvent pas être supprimés.',
    deleteUserConfirmLabel: 'Saisissez l’adresse e-mail du client pour confirmer',
    deleteUserSuccess: 'Le compte de {{email}} a été supprimé.',
    owner: 'Propriétaire',
    tier: 'Niveau',
    interval: 'Intervalle',
    start: 'Début',
    cancelAtEnd: 'Annuler à la fin',
    eppAdmin: 'Admin EPP',
    general: 'Général',
    auth: 'Authentification',
    poll: 'Sondage',
    statistics: 'Statistiques',
    resources: 'Ressources',
    domain: 'Domaine',
    contact: 'Contact',
    host: 'Hôte',
  },
  subscription: {
    calculatingPlanChange: 'Calcul du changement de plan...',
    upgradeTo: 'Passer au plan {{tier}}',
    upgradeImmediate: 'Vous obtiendrez un accès immédiat à toutes les fonctionnalités {{tier}}.',
    planUpgrade: 'Mise à niveau du plan {{tier}}',
    daysUntil: '{{days}} jours avant le {{date}}',
    prorationExplanation: "Il s'agit de la différence de prix entre {{currentTier}} et {{newTier}} pour la période restante de votre abonnement.",
    whatYouGet: 'Ce que vous obtiendrez :',
    upToWebsites: "Jusqu'à {{count}} sites web (actuellement {{current}})",
    upToCustomDomains: "Jusqu'à {{count}} domaines personnalisés par site (actuellement {{current}})",
    redirectToPayment: 'Vous serez redirigé pour effectuer le paiement.',
    createOrder: 'Créer la commande',
    downgradeTo: 'Rétrograder vers {{tier}}',
    downgradeAtEnd: 'Votre plan changera à la fin de votre période de facturation actuelle.',
    cannotDowngradeYet: 'Impossible de rétrograder pour le moment :',
    planChangesOn: 'Le plan change le <strong>{{date}}</strong>',
    continueAccess: 'Vous continuerez à avoir accès à toutes les fonctionnalités {{tier}} jusque-là.',
    afterDowngrade: 'Après la rétrogradation :',
    maxWebsites: 'Maximum {{count}} site(s) web',
    maxCustomDomains: 'Maximum {{count}} domaine(s) personnalisé(s) par site',
    noRefund: 'Aucun remboursement ne sera effectué. Vous pouvez annuler ce changement planifié à tout moment avant la fin de votre période de facturation.',
    scheduleDowngrade: 'Planifier la rétrogradation',
    upgradeComplete: 'Mise à niveau terminée !',
    downgradeScheduled: 'Rétrogradation planifiée',
    nowHaveAccess: 'Vous avez maintenant accès à toutes les fonctionnalités {{tier}}. Profitez-en !',
    planWillChange: 'Votre plan passera à {{tier}} le {{date}}.',
    somethingWentWrong: "Une erreur s'est produite",
    done: 'Terminé',
    downgradeToast: 'Rétrogradation vers {{tier}} planifiée pour le {{date}}',
    changingTo: 'Changement vers <strong>{{tier}}</strong> le {{date}}',
    scheduledChangeCancelled: 'Changement planifié annulé',
    failedToCancelChange: "Échec de l'annulation du changement planifié",
    failedToCalculate: 'Échec du calcul du changement de plan',
    failedToCreateOrder: 'Échec de la création de la commande de mise à niveau',
    failedToSchedule: 'Échec de la planification du déclassement',
    validationFailed: 'Échec de la validation',
    // FreePlanDialog
    freePlan: 'Plan gratuit',
    yourPlan: 'Votre plan',
    freeLabel: 'Gratuit',
    freePlanDescription: 'Le plan gratuit vous permet de créer et de partager un brouillon. La publication le met sur Internet sous votre domaine et nécessite un plan.',
    usage: 'Utilisation',
    websites: 'Sites web',
    customDomains: 'Domaines personnalisés',
    notAvailable: 'Non disponible',
    freePlanLimitations: 'Limitations du plan gratuit',
    publishNeedsPlan: 'La publication nécessite un plan',
    noCustomDomain: 'Pas de domaine personnalisé',
    upgradeToUnlock: 'Passez à un plan supérieur pour débloquer',
    permanentPublicUrl: 'URL publique permanente',
    customDomainSupport: 'Support de domaine personnalisé',
    fastSecureDelivery: 'Diffusion rapide et sécurisée avec HTTPS',
    viewPlansAndPricing: 'Voir les plans et tarifs',
    // GoLiveDialog
    readyToGoLive: 'Prêt à publier ?',
    goLiveDescriptionWithName: 'Le plan gratuit vous permet de créer et de partager "{{name}}" comme brouillon. La publication le met sur Internet sous votre domaine et nécessite un plan.',
    goLiveDescription: 'Le plan gratuit vous permet de créer et de partager un brouillon. La publication le met sur Internet sous votre domaine et nécessite un plan.',
    whatsIncluded: 'Ce qui est inclus :',
    draftModeNotice: 'Votre site est un <strong>brouillon</strong>. Seules les personnes à qui vous envoyez son lien de prévisualisation peuvent le voir. La publication le rend public.',
    // ExpiredPlanDialog
    renewPlan: 'Renouveler le plan',
    expired: 'Expiré',
    ends: 'Se termine',
    expiredDescription: 'Votre abonnement a expiré. Renouvelez-le pour continuer à utiliser vos sites web.',
    expiredNotice: 'Votre plan {{tier}} ({{interval}}) a expiré le {{date}}.',
    expiredWarning: "Vos sites web ne seront bientôt plus accessibles au public. Renouvelez votre abonnement pour rétablir l'accès.",
    plan: 'Plan',
    billing: 'Facturation',
    monthly: 'Mensuel',
    yearly: 'Annuel',
    expiredOn: 'Expiré le',
    renewTierPlan: 'Renouveler le plan {{tier}}',
    renewCheckoutNotice: "Vous serez redirigé vers le paiement. Votre abonnement sera prolongé de {{period}} à partir d'aujourd'hui.",
    oneMonth: '1 mois',
    // PlanManagementDialog
    managePlan: 'Gérer le plan',
    managePlanDescription: 'Consultez les détails de votre abonnement et gérez votre plan.',
    cancelledNotice: 'Votre abonnement prendra fin le <strong>{{date}}</strong>. Vous ne serez plus facturé.',
    billedInfo: 'Facturé {{interval}} \u00b7 {{action}} le',
    planFeatures: 'Fonctionnalités du plan',
    websitesCount: '{{count}} site(s) web',
    customDomainsCount: '{{count}} domaine(s) personnalisé(s)',
    upgradeToBusiness: 'Passer au plan Business',
    downgradeToStarter: 'Rétrograder vers Starter',
    upgradeHint: 'Passez à un plan supérieur à tout moment. Ne payez que la différence de prix pour les jours restants.',
    downgradeHint: 'La rétrogradation prendra effet à la fin de votre période de facturation.',
    cancelSubscription: "Annuler l'abonnement",
    cancelSubscriptionTitle: 'Annuler votre abonnement ?',
    cancelSubscriptionDescription:
      "Votre abonnement restera actif jusqu'au <strong>{{date}}</strong>. Après cette date, vous perdrez l'accès à vos sites web et domaines personnalisés. Vous pouvez le réactiver ici à tout moment d'ici là.",
    keepSubscription: "Conserver l'abonnement",
    yesCancel: 'Oui, annuler',
    cancelSubscriptionSuccess: "Annulation de l'abonnement planifiée pour le {{date}}.",
    cancelSubscriptionFailed: "Impossible d'annuler l'abonnement",
    resumeSubscription: "Réactiver l'abonnement",
    resumeSubscriptionTitle: 'Réactiver votre abonnement ?',
    resumeSubscriptionDescription: 'Votre plan {{tier}} sera renouvelé automatiquement le <strong>{{date}}</strong>, et votre moyen de paiement par défaut sera alors débité.',
    resumeSubscriptionDismiss: 'Pas maintenant',
    resumeSubscriptionSuccess: 'Abonnement réactivé. Il sera renouvelé le {{date}}.',
  },
  home: {
    swissAccreditedRegistrar: 'Registrar accrédité suisse',
    heroTitle: 'your web tech',
    heroSubtitle: 'Enregistrez des domaines .ch/.li - rapide, simple et clair.',
    heroSubtitlePrice: 'Domaines .ch et .li à {{price}} par an, chaque année.',
    sameRenewalPrice: 'Même prix à chaque renouvellement',
    freeTransfers: 'Transferts gratuits',
    comparePrices: 'Voir et comparer les prix',
  },
  whois: {
    title: 'Recherche Whois',
    subtitle: 'Prend en charge tous les TLD. Minimal et rapide.',
    placeholder: 'Entrez un nom de domaine, ex. example.com',
    check: 'Vérifier',
    noData: 'Aucune donnée WHOIS disponible pour ce domaine.',
    disclaimer: "La recherche Whois n'est pas en temps réel et peut prendre jusqu'à 24 heures.",
    disclaimerTld: 'Selon le TLD, les informations peuvent ne pas être entièrement disponibles.',
    summaryFor: 'Résumé Whois pour',
    domain: 'Domaine :',
    status: 'Statut :',
    nameServers: 'Serveurs de noms :',
    created: 'Créé :',
    expires: 'Expire :',
    updated: 'Mis à jour :',
    whoisServer: 'Serveur WHOIS :',
    dnssec: 'DNSSEC :',
    registrar: "Bureau d'enregistrement",
    registrant: 'Titulaire',
    administrative: 'Administratif',
    technical: 'Technique',
    billing: 'Facturation',
    registrarName: 'Nom :',
    registrarWebsite: 'Site web :',
    registrarEmail: 'E-mail :',
    registrarPhone: 'Téléphone :',
  },
};
